export default {
  common: {
    common_01: 'エラーが発生しました。',
    all: '全体',
    sold_out: '売り切れ',
    currency: '￥{{price}}',
    마플샵: 'MarppleShop',
  },
  crew: {
    authorization: {
      signup_00: '新規会員登録',
      signup_01: 'メールアドレス',
      signup_02: '名前',
      signup_03: '社員番号',
      signup_04: '利用規約に同意',
      signup_05: '個人情報収集及び利用に同意',
      signup_06: '個人情報の第三者提供に同意',
      signup_07: '14歳以上確認',
      signup_08: '[選択] メールマーケティングの受信に同意',
      signup_09: '見る',
      signup_10: 'ログイン',
      signup_11: '利用規約に同意してください。',
      signup_12: '個人情報収集の利用に同意してください。',
      signup_13: '個人情報の第三者提供に同意してください。',
      signup_14: '13歳以上会員登録が可能です。',
      signup_15: '既存のユーザーが存在します。 ご確認ください。',
      signup_17: '認証が完了されていません。',
      signup_18: '所属する法人はNBOXサービスの対象ではありません',
      signup_18_mobile: '所属法人は<br/>NBOXサービスの対象ではありません。',
    },
    crew_01: 'ホームに戻る',
    suspensions: {
      type: {
        copyright: '著作権侵害',
        counterfeit: '偽造品の販売',
        adult_policy_violation: '成人認証規定違反',
        internal_policy_violation: 'マプルショップ内部規定違反',
      },
      user_type: {
        individual: '個人',
        group: '団体',
      },
    },
    solutions: {
      status: {
        answer: '回答完了',
        not_answer: '回答待ち',
        not_selling: '販売停止',
        selling: '販売再開',
        suspension: 'ショップ運営停止',
        not_suspension: 'ショップ運営中',
      },
      header: {
        title: '通報の受付',
        description: '自分のショップや商品などに寄せられた通報を確認できます。',
      },
      table: {
        suspension_reason: {
          copyright: '著作権侵害 {{count}} 件',
          counterfeit: '偽造品の販売 {{count}} 件',
          adult_policy_violation: '成人認証規定違反 {{count}} 件',
          internal_policy_violation: '内部規定違反 {{count}} 件',
        },
      },
      thread_status: {
        in_progress: '回答期限まで{{day}}日です。',
        re_in_progress: '再リクエストの期限まで、あと{{day}}日です。',
        answer_expiration: '再訴期間満了 / スレッド終了',
        end: 'スレッド終了',
      },
      form: {
        type: '申告の種類',
        user_type: '権利侵害を受けた当事者',
        name: '申告者',
        birth: '生年月日',
        owner: '商標権/デザイン権の保有者',
        owner_placeholder: '個人名、法人名、団体名などを入力してください。',
        contact: '連絡先',
        email: 'メール',
        email_placeholder: 'メールアドレスを入力してください',
        email_description:
          '上記のメールアドレスと連絡先に申告の進行状況が送信されます。必ず正確に記入してください。',
        product_url: '申告商品URL',
        product_url_placeholder: 'ex) https://marpple.shop/kr/shop_domain/products/12345',
        store_url: 'クリエイターショップのURL',
        store_url_placeholder: 'ex) https://marpple.shop/kr/shop_domain',
        product_info: '商品情報',
        reason: '申告の理由',
        reason_placeholder: '円滑な申告のために内容を具体的に記入してください。',
        submit: '申告を提出する',
        thread_submit: 'スレッドを作成',
        confirm: '通報を提出した後は内容を修正できません。\n続行しますか？',
        answer: '回答する',
        file: '添付ファイル',
        description: '詳細内容',
        required_document: '必要書類',
        required_document_description:
          '商標権・意匠権および該当クリエイターの侵害を証明できる資料を添付してください。（ファイルサイズ：10MB以下）',
        user_document: '団体証明書類',
        user_document_description: '企業・団体の場合で、\n提出者が代表者でない場合',
      },
      item: {
        report_type: '種類',
        reported_creator: '通報対象のクリエイター',
        reported_product_url: '通報された商品のURL',
        report_detail: '通報の詳細内容',
        reportor_email: '通報者のメールアドレス',
      },
    },
  },
  customer_orders: {
    pick_up: 'ピックアップ',
    possible_pick_up: 'ピックアップ可能',
    re_purchase: '再購入',
    empty_order_desc: '購入履歴がありません。',
    cannot_purchase: '購入不可商品',
    cannot_purchase_desc: '購入することができません！',
  },
  layout: {
    footer1: '(株)マープルコーポレーション',
    footer2: 'カスタマーセンター',
    footer3: '通報センター',
    footer4: 'セラー申請',
    footer5: '企業セラー申請',
    footer6: '個人情報処理方針',
    footer7: '利用規約',
    footer8:
      'クリエイター配送商品の場合、(株)マープルコーポレーションは通信販売仲介者として通信販売の当事者ではなく、商品取引及び取引情報に対して責任を負いません。',
    footer9: '© 2025 MARPPLE CORP.',
    footer: {
      company_name: '(株)マープルコーポレーション',
      ceo: '代表',
      ceo_name: 'パク·ヘユン',
      customer_center: 'カスタマーセンター',
      customer_center_info: '(平日10:00~18:00)',
      company_registration_info: '事業者登録番号',
      company_registration_number: '105-88-13322',
      address: '住所',
      address_info: 'KR 08589 10F, 75-24, Gasan digital 1-ro, Geumcheon-gu, Seoul, Korea',
      email: 'メールアドレス',
      report_center: '通報センター',
      apply_seller: 'セラー申請',
      terms_and_conditions: '利用規約',
      privacy_policy: '個人情報処理方針',
      instagram: 'インスタグラム',
      youtube: 'ユーチューブ',
      twitter: 'ツイッター',
      blog: 'ブログ',
      marpple_corp: 'マープルコーポレーション',
      nbox: {
        address: '京畿道城南市盆唐区板橋路256-7',
        phone: '電話番号',
        phone_number: '{{tel}}(平日10:00~18:00)',
        company_registration_number: '220-87-17483号',
        ceo_name: 'イ·ジョンホン',
        footer1: 'ネクソンコリア',
        footer9: '© NEXON Korea Corporation All Rights Reserved.',
      },
    },
    drawer: {
      menu: {
        review: 'レビュー',
        product: '公式商品',
        home: 'ホーム',
      },
    },
  },
  my_page: {
    my_page_01: '<b>{{name}}</b>様, こんにちは。 👋',
    my_account_01: 'プロフィールイメージ',
    my_account_02:
      '10MB以内のイメージファイルをアップロードしてください。<br />(イメージアップロード形式:JPG、JPEG、PNG)',
    my_account_03: 'ファイルがありません。',
    my_account_04: 'ログインが必要です。',
    my_account_05: 'ファイルが保存されていません。',
    my_account_06: '削除',
    my_account_07: '更新',
    my_account_08: 'アップロード',
    like_product_01: 'いいね',
    like_product_02: 'いいねを押した商品がありません。',
    nick_name: 'ニックネーム',
    save: '修正',
    email: 'メール',
    mobile: '番号',
    validation_nickname: '韓国語、英語、数字のみ入力可能で、16バイトまで登録できます。',
    agree_email: '広告受信',
    view_agree_email: '表示',
    no_email: '登録されたメールアドレスがありません。',
    file_valid_5mb: '5MB以下のファイルをアップロードしてください。',
    file_valid_fail: 'アップロード失敗',
  },
  order: {
    '배송지 변경': 'お届け先変更',
    recipient: '受取人',
  },
  checkout: {
    receipt: {
      receipt_01: '注文が完了しました。',
      receipt_01_mobile: '{{nickname}}様!',
      receipt_01_compact: '注文が完了しました。',
      receipt_02: 'お楽しみにお待ちください！',
      receipt_02_compact: '特別さを込めて製作し配送いたします。<br />お楽しみにお待ちください！',
      download_purchase_card: '購入認証カードをダウンロードしてみてください。',
    },
  },
  product: {
    sort: {
      최신순: '最新順',
      '리뷰 많은 순': 'レビューが多い順',
      인기순: '人気順',
      '낮은 가격 순': '価格が低い順',
      '높은 가격 순': '価格が高い順',
    },
    review: {
      count: '商品レビュー',
      score: '評点',
    },
    n_viewing: {
      normal: '<span>今</span><b>{{n}}</b><span>人のファンが注目中！</span>',
      compact: '{{n}}人が閲覧中',
    },
  },
  plus_admin: {
    plus_admin_01: 'テーマ選択',
    plus_admin_02: 'ブラックテーマ',
    plus_admin_03: 'ホワイトテーマ',
    banner_01: 'サブタイトル',
    banner_02: '多言語対応で、入力時に左側からプレビューが可能です。',
    banner_03: 'タイトル',
    plus_admin_04: '背景カラー選択',
    popup_store: {
      list_page_title: 'ポップアップストア管理',
      detail_page_title: 'ポップアップストア管理',
      detail_page_desc:
        '画像推奨サイズ: 横3840px * 縦2000px / 登録可能形式: JPG, JPEG, PNG, GIF, WEBP / 容量: 8MB以下 (ポップアップストアがぞうすいしょうサイズ: よこ3840px * たて2000px / とうろくかのうけいしき: JPG, JPEG, PNG, GIF, WEBP / ようりょう: 8MBいか)',
    },
  },
  home: {
    plus_home: {
      plus_home_01: '人気商品',
      plus_home_02: '最も愛されている公式商品',
      plus_home_03: '遅れる前に買いましょう。',
      plus_home_04: 'まさに今！チェックすべきグッズ',
      plus_home_05: '購入した人たちのレビューが気になる時',
      plus_home_06: 'リアルタイムレビュー',
      channel_on: 'NBOX チャンネル on',
      nbox_hot_item: '今注目するNBOXホットテム',
    },
  },
  community: {
    input: '入力',
    comment_place_holder: 'コメントを残してみてください。',
    review: 'レビュー',
    community_01: '変更事項はありません。',
  },
  cart: {
    title: 'カート',
  },
  goods_types: {
    mps: 'MarppleShop制作配送',
    pbg: 'クリエイター配送',
    tpl: 'MarppleShop配送',
    dtg: 'デジタル/電子書籍',
    mps_delivery: 'MarppleShop制作配送',
    pbg_delivery: 'クリエイター配送',
    tpl_delivery: 'MarppleShop配送',
    tooltip: {
      mps_title: 'MarppleShop制作配送商品',
      mps_description:
        'MarppleShopで直接制作して配送する商品です。<br />決済金額に関わらず基本配送料は同じく請求され、離島・山間地域は追加料金が発生する場合があります。',
      pbg_title: 'クリエイター配送商品',
      pbg_description:
        'クリエイターが配送する商品です。<br />クリエイターによって配送料や所要期間が異なる場合があります。',
      tpl_title: 'MarppleShop配送商品',
      tpl_description:
        'MarppleShopから直接配送する商品です。<br />決済金額に関わらず基本配送料は同じく請求され、離島・山間地域は追加料金が発生する場合があります。',
    },
  },
  product_types: {
    custom: 'カスタム注文',
    handmade: 'ハンドメイド',
    pod: 'オーダーメイド',
  },
  product_detail: {
    tab01: 'ストーリー',
    tab02: '商品情報',
    tab03: '購入/配送',
    tab04: 'レビュー',
    tab05: 'ファンレター',
    unfold_btn: 'もっと見る',
    fold_btn: '閉じる',
    left_count: '残り{{count}}点です',
    left_time: '締切{{time}}前',
    coming_soon: 'Unopened',
    total_price: 'Total price',
    badges: {
      sold_out: 'Sold out',
      limited: 'Limited',
    },
    recommend_and_fan_letter: {
      recommend_title: '関連商品',
    },
    purchase_info: {
      th_1: '商号',
      th_2: 'クリエイター名',
      th_3: '事業者番号',
      th_4: 'メール',
      th_5: '連絡先',
      th_6: '回収配送料',
      th_7: '返送先',
      th_8: '事業者番号',
      th_9: '配送方法',
      th_10: '配送地域',
      th_11: '配送期間',
      th_12: 'CS',
      th_13: '往復送料',
      delivery_info: '配送情報',
      delivery_company: '一般宅配便',
      delivery_desc_mps:
        'すべての商品は、顧客の注文に合わせて新商品として製作および配送されます。<br/>ただ今注文すると<span sytle=”color:{{color}};”>{{start}}</span>から製作プロセスが開始され、<span sytle=”color:{{color}};”>{{end}}</span>までに出荷される予定です。',
      delivery_desc_tpl:
        'ただ今注文すると<span style="color:{{color}};">{{start}}</span>から製作プロセスが開始され、<span style="color:{{color}};">{{end}}</span>までに出荷される予定です。',
      delivery_period_mps:
        '商品出荷後、1~3営業日以内にお受け取りが可能で離島地域や配送業者の物量が多い場合期間がもう少しかかる場合があります。',
      delivery_period_tpl:
        '商品出荷後、1~3営業日以内にお受け取りが可能で離島地域や配送業者の物量が多い場合期間がもう少しかかる場合があります。',
      all_country: '全国',
      delivery_faq_btn: '配送FAQを見に行く',
      exchange_info: '交換/返品のご案内',
      exchange_desc_mps:
        'すべてのMarppleShop制作配送商品は<span style="color:{{color}};">オーダーメイド</span>方式で製作され、お客様都合による交換/返品は受け付けておりません。\nただし、受領した商品の不良または誤配送された場合は、7日以内にカスタマーセンターまたはメール、お問い合わせフォームにてお申し付けいただければ、交換及び返品·返金が可能です。',
      exchange_tel: '<a href="tel:{{tel}}">{{tel}}</a>',
      exchange_email: '<a href="mailto:{{email}}">{{email}}</a>',
      exchange_widerrufsrecht_btn: '請約撤回制限要件のご案内',
      exchange_guarantee_btn: '品質保証基準のご案内',
      mps_qna_btn: 'お問い合わせフォーム',
      qna_btn: '1：1 お問い合わせ',
      exchange_faq_btn: '交換/返品FAQを見に行く',
      report_info: '申告のご案内',
      report_desc:
        'MarppleShopはクリエイターと消費者、著作権保護のために申告センターを運営しています。<br/>MarppleのShop内部規定に違反するセラーと第三者著作物の無断盗用または肖像権を侵害したと判断される商品を申告することができます。',
      report_btn: '申告する',
      creator_info: 'クリエイター情報',
      dtg_info_title: 'デジタル/電子書籍を購入する前に、必ずご確認ください！',
      dtg_info_item_1: 'すべての商品は実物ではなく、デジタルファイル形式の商品です。',
      dtg_info_item_2: '決済完了後、購入履歴から7日間ダウンロードできます。',
      dtg_info_item_3:
        'クリエイターが設定したライセンス範囲を超えて利用した場合、処罰される可能性があります。',
      dtg_info_item_4: 'デジタル/電子書籍の特性上、購入後はいかなる理由でも交換・返金はできません。',
    },
    review: {
      empty_title: 'まだ登録されたレビューがありません。',
      empty_title_mps: '最初のレビューの主人公になってみてください！',
      empty_text: '初レビューの主人公になってみてください！',
      empty_text_mps:
        '真心のこもったレビューは、クリエイターにとって大きな力になります。<br/>レビューを登録し、ポイントをゲットしてください！',
      show_more: '{{count}} レビュー',
      option: 'オプション:{{option_name}}',
      sns_review: 'SNSレビュー',
    },
    nbox: {
      pick_title: 'ネクソンピックアップ',
      pick_desc1: '無料',
      pick_desc2: 'ネクソンピックアップ可能',
    },
    max_purchase_per_user: '1人当たり最大{{count}}個まで購入可能な商品です。',
    possible_quantity: '合計{{count}}個まで追加できます！',
    already_possible_quantity_title: '1人当たり購入可能な数量超過',
    already_possible_quantity: 'すでに購入した商品か、カートに入っています。',
    cta: {
      coming_soon: '近日購入可能。',
      not_approve: '承認後に購入可能です。',
      sold_out: '商品が売り切れました！',
      end_sale: '販売が終了されました！',
      only_pc: 'デジタル商品はPCでのみ購入可能です。',
      purchased_dtg: 'すでに購入した商品です!',
      cart: 'カート',
      buy_now: 'ご購入手続きへ',
      buy: 'カートに入れる',
    },
    errors: {
      option_required: 'オプションを選択していません。<br/>商品のオプションを選択してください。',
      option_required_mo: 'オプションを選択していません。<br/>商品のオプションを選択してください。',
    },
    purchase_delivery: {
      title: '配送のご案内',
      pd01: '今ご注文いただくと<span style="color:{color};">{start}</span>から<span style="color:{color};">{end}}</span>の間に出荷予定です。',
      pd02: 'マープルショップのオーダーメイド商品と一緒に注文する場合、オーダーメイド商品の出庫日に合わせて一緒に配送されます。',
      pd03: 'ご注文いただいた商品は、3日以内に発送が開始される予定です。物流状況によっては、配送が遅れる場合がありますのでご了承ください。',
      info: {
        '01': '단, 수령하신 상품이 불량이거나 오배송된 경우에는 30일 이내 고객센터 또는 이메일, 1:1 문의로 연락주시면 교환 및 반품 환불이 가능합니다.',
        '02': '교환/반품 신청은 고객센터 또는 이메일로 접수해주시면 택배사 반품 접수를 도와드립니다.',
        '03': '반품 양식서를 작성하셔서 상품과 함께 포장해주세요. (반품양식서 누락시 환불이 지연될 수 있습니다.)',
        '04': '타 택배사 또는 임의로 택배를 보내시면 반송될 수 있으며 분실 및 접수 누락으로 환불이 지연되거나 불가할 수 있습니다.',
        a_01: '교환/반품 요청 기간은 상품 개봉 및 훼손 없이, 배송 완료 후 7일 이내인 경우에만 환불이 가능합니다.',
        a_02: '예외로 맞춤형 주문제작 상품의 경우 단숨 변심으로 인한 주문취소/교환/반품이 어렵습니다.',
        b_01: '본 상품은 <strong>맞춤형 주문제작 상품</strong>으로, 단순 변심으로 인한 주문취소/교환/반품이 어렵습니다.',
        c_01: '본 상품은 일반 주문제작 상품으로, 교환/반품 요청 기간은 상품 개봉 및 훼손 없이 배송 완료 후 7일 이내인 경우에만 환불이 가능합니다.',
      },
      case: {
        title: '반품/교환 불가능한 경우',
        '01': '맞춤형 주문 제작 상품의 경우',
        '02': '반품요청 기간이 지난 경우',
        '03': '구매자의 책임 있는 사유로 상품 등이 훼손 또는 멸실된 경우',
        '04': '구매자의 책임 있는 사유로 포장이 훼손되어 상품 가치가 현저히 상실된 경우 (예 : 식품, 화장품, 향수류, 음반, 전장류 등)',
        '05': '구매자의 사용 또는 일부 소비에 의하여 상품의 가치가 현저히 감소한 경우 (라벨 제거, 태그 제거 등)',
        '06': '상품 고지 내역과 상이, 계약 내용과 다르게 이행된 경우 상품 수령 후 3개월 이내 혹은 표시/광고와 다른 사실을 안 날로부터 30일 이내 둘 중 하나 경과 시 반품/교환 불가',
        '07': '복제가 가능한 상품 등의 포장을 훼손한 경우 (예 : CD/DVD/GAME/도서의 경우 포장 개봉 시)',
      },
    },
    dtg: {
      file_type: '形式',
      hyper_link: 'リンク',
      license: 'ライセンス',
    },
    options: {
      color: 'Color',
      preview_by_device: 'スマートフォン適用',
      size: 'Size',
      quantity: 'Quantity',
      device: 'Device',
      custom: 'Custom Option',
      preview: 'Preview',
      type: 'Type',
      hyper_link: 'Hyper Link',
      license: 'License',
      size_guide: 'Size Guide',
    },
    brand_delivery: 'ブランド直送商品',
    creator_delivery: 'クリエイター配送商品',
    creator_delivery_desc:
      'クリエイターが配送する商品です。クリエイターによって配送料や所要期間が異なる場合があります。',
    mps_delivery: 'MarppleShop制作配送商品',
    mps_delivery_desc:
      'MarppleShopが直接製作・配送する商品です。決済金額に関わらず、基本配送料は同一で請求され、離島・山間部では追加料金が発生する場合があります。',
    tpl_delivery: 'MarppleShop Delivery',
    tpl_delivery_desc:
      'MarppleShopが直接配送する商品です。決済金額に関わらず、基本配送料は同一で請求され、離島・山間部では追加料金が発生する場合があります。',
    total_label: 'Total <span class="dynamic-value">{{count}}</span>',
    not_approve: '販売承認後に購入可能です。',
    sold_out_products: 'Sold Out',
    end_sale: 'Sold Out',
    only_pc: 'Only PC',
    purchased_dtg: 'Already Bought it!',
    cart: 'Add to Cart',
    buy: 'Buy',
    noti: {
      left: '{{left}} 残っています！',
      end_of_sale: '{{start_at}} ~ {{end_at}}',
      until_close:
        '締め切りまで&nbsp;<span class="remain_time" data-start_at="{{start_at}}" data-end_at="{{end_at}}">{{remain_time}}</span>',
      until_open:
        'オープンまで&nbsp;<span class="remain_time" data-start_at="{{start_at}}" data-end_at="{{end_at}}">{{remain_time}}</span>',
    },
    delivery_info: {
      info_label: 'Delivery',
      start_date_label: '出荷日',
      expect:
        'ただ今注文すると&nbsp;<span class="pd-guide__start-end-strong" style="color: {{color}};">{{start}} ~ {{end}}&nbsp;</span>の間に出発します！',
      parcel: '普通の宅配',
      message1: '特別さを込めてお届けします。<br />わくわくする気持ちでお待ちください！',
      free_ship: '無料配送',
      base_price: '送料',
      addi_price: '追加送料',
      label_1: '配送方法',
      label_2: '配送地域',
      label_3: '送料',
      label_4: '配送期間',
      label_5: '送料',
      label_6: '追加送料',
      desc_1:
        '商品は出荷後、営業日基準で1~3日以内にお届け可能です。ただし、離島や山間部地域、または宅配業者の物量が多い場合、もう少し時間がかかることがあります。',
      message2: '注文急増により配送が遅れる場合があります。{{- br}}遅れる際はテキストでお知らせします。',
    },
    best_seller_title: 'Best Seller',
    best_seller_subtitle: '人気商品',
    link_delivery: '配送FAQ',
    link_chat: '1：1 お問い合わせ',
    link_change: '交換/返品FAQ',
    option_modal_title: 'Option',
    quality_modal: {
      p1: '本商品は厳格な品質管理のもとで製造され、外観、規格、物性検査に合格した商品です。',
      p2: '商品の寿命を延ばすために、商品に添付されている取扱注意事項や洗濯方法を必ず確認してください。また、品質に問題がある場合はカスタマーサービスにご連絡ください。',
      cs_title: 'CS',
      email_title: 'メール',
    },
    retraction_modal: {
      p1: '着用跡、洗濯跡、臭い、汚れ、勝手な修繕跡など<br/>商品が損傷していたり不良品であっても着用または使用した場合は、<br/>交換・返品はできません。',
      p2: '申込撤回制限要件<br />(第17条第2項第6号および同法施行令第21条)',
      li1: '詳細サイズは測定方法と位置により1〜3cmの誤差が生じることがあります。記載された詳細サイズと実測値の誤差(1〜3cm)についての不良品処理はできず、交換・返金の理由にはなりません。',
      li2: '販売される商品は各ブランド、卸売業者からそれぞれのサンプリングを経て供給される製品であるため、特定のブランドまたはお持ちの商品と詳細サイズが異なる場合があります。実測購入時には詳細サイズを必ずご確認ください。',
      li3: 'サイズ測定は商品を床に広げた後、端から端まで測定する必要があり、伸縮性のある素材の場合は、引っ張らずに床に広げた状態のまま測定する必要があります。誤差範囲以外の誤った測定による返品および交換は難しい点ご了承ください。',
    },
    private: {
      title: 'この商品は販売終了または中止された商品です。',
      description: 'この商品は現在、販売が終了しているか、<br/>削除されて確認できません。',
      btn: '他の商品を見る',
    },
    brand_delivery_desc: 'この商品はブランドが直接発送する商品です。 購入/配送をご確認ください！',
    tab02_ness: '商品情報',
    tab03_ness: '購入/配送',
    ness: {
      not_available_description:
        '선택하신 상품은 현재 판매가 종료되거나,<br />삭제되어 확인하실 수 없습니다.',
    },
  },
  review: {
    comment_header: '商品レビューを残してください。',
    write_review: 'レビュー作成',
    comment_title: 'レビュー内容',
    placeholder: '15文字以上書いてください。',
    desc1: 'すべてのレビューには、少なくとも1つの画像を含める必要があります。',
    desc2:
      '商品とは関係のないレビューや、不適切な言葉を含むレビュー、その他のレビュー方針に違反するレビューは、通知なしにブラインド化され、警告措置が取られることがあります。',
    sns_share: 'SNS',
    agree: '作成レビューはコンテンツとして活用します。',
    remove: 'レビュー削除',
    remove_desc: '作成されたレビューを削除しますか？',
    remove_comment: 'コメント削除',
    remove_comment_desc: 'コメントを削除しますか？',
    more: 'More',
    desc3: '画像形式 : jpeg、png、gif / 容量 5MB',
    thankyou_title: 'Review Completed',
    thankyou_desc: 'レビューを作成していただきありがとうございます。',
  },
  creator: {
    sub_title: 'クリエイター',
    sort: {
      최신순: '新規登録順',
      인기순: '人気順',
    },
    header_title: 'クリエイター',
    rank: {
      top_10_ranking: '{{interval}} \nranking',
      top_10_text: 'top 10',
    },
  },
  limit_product: {
    limit_product_01: '限定版',
  },
  ness: {
    mypage: {
      main_01: '注文・配送中の商品',
      main_02: '自分が書いたレビュー',
      main_03: 'いいねした商品',
      main_01_mobile: '注文・配送',
      main_02_mobile: 'レビュー',
      main_03_mobile: 'いいね',
      main_04: 'マイストア',
      main_05: 'セラースタジオ',
      main_06: 'プラスアドミン',
      main_07: 'アカウント設定',
      main_08: 'ログアウト',
      main_09: '購入履歴',
      main_10: 'マイレビュー',
      main_11: 'いいね',
      main_12: '1：1 お問い合わせ',
      main_13: '申告受付サービス',
      main_14: 'サイト利用時の注意事項',
      like_01: '<span>私のいいね商品 <span class="count">{{count}}</span></span>',
      like_02: '<span>私のいいねストア <span class="count">{{count}}</span></span>',
      like_01_mobile: '<span>いいね商品 <span class="count">{{count}}</span></span>',
      like_02_mobile: '<span>いいねストア <span class="count">{{count}}</span></span>',
      like_03: 'いいね商品が見つかったら、いいねボタンをクリックしてください。',
      like_04: 'いいねストアが見つかったら、いいねボタンをクリックしてください。',
      review_01: 'まだレビューがありません。',
      nexon_account_info: 'NEXON勘定',
      nexon_account_modify: 'NEXON情報を変更',
      nexon_account_modify_mo: 'NEXON情報の変更',
      nexon_agree_info: '受信設定の状態は、[NEXON.com>マイ情報]で確認できます。',
    },
    order: {
      order_01: 'NESS配送',
      order_02: 'クリエイター配送',
      revise_shipping: 'お届け先の変更',
      order_custom: '注文制作配送',
      order_01_add: 'NEXON ESSENTIAL配送離島山間部',
      order_02_add: '販売者配送離島山間部',
      order_custom_add: '注文製作商品配送離島山間部',
    },
    home: {
      home_01: '新商品',
      home_02: '人気商品',
      home_03: '{{-count}}個の特別販売商品をもっと見る',
      home_04: '{{brand}}ブランデッドコンテンツ',
      home_05: 'レビュー',
    },
    product: {
      only_limited: '特別販売のみ表示',
      only_limited_mo: '特別販売のみ',
      only_stock_available: '品切れ商品を除く',
      only_stock_available_mo: '品切れ除く',
      product_03: '新商品',
      product_04: 'New Arrivals',
      product_05: '特別販売商品',
      product_06: 'Special Offer',
      product_07: '人気商品',
      product_08: 'Best Seller',
      product_09: 'Empty Product List',
      product_10: '希望条件に合った商品がありません。',
      product_11: 'Coming Soon',
      custom: '注文製作商品',
    },
    product_sort: {
      default: '基本順',
      popular: '人気順',
      recent: '最近登録順',
      most_liked: 'いいね順',
      price_high_to_low: '高い価格順',
      price_low_to_high: '低い価格順',
    },
    product_badge: {
      sale: 'Sale',
      new: 'New',
      collection: 'Collection',
      ranking: 'Ranking',
      quantity_limited: '{{count}} Left',
      limited: '',
      edition: '',
      left: '',
      day_one: '',
      hour: '',
      minute: '',
    },
    review: {
      count_one: '',
      count_other: '',
    },
    footer: {
      company_name: '(株)ネクソンコリア',
      customer_center: 'カスタマーセンター',
      ceo: '代表取締役',
      ceo_name: '강대현·김정욱',
      address: '住所',
      address_info: '경기도 성남시 분당구 판교로 256번길 7',
      company_registration_info: '事業者登録番号',
      company_registration_number: '220-87-17483',
      footer1: '利用規約',
      footer2: '個人情報処理方針',
      footer3: 'サービス利用案内',
      footer4: '電話番号',
      footer5: '平日',
      footer6: '昼休み',
      footer7: '祝日・週末休業',
      footer8: '事業者情報確認',
      footer9: '営業時間',
      footer10: 'メール',
      footer11:
        'NEXON ESSENTIAL内で販売される一部の商品について、（株）ネクソンコリアは通信販売仲介者であり、通信販売当事者ではなく、販売者が登録した商品、商品情報および取引に関する責任を負いません。',
      footer12: 'ホスティングサービス提供者',
      footer13: '(株)マープルコーポレーション',
      address_info_part1: '京畿道城南市盆唐区&nbsp;',
      address_info_part2: '板橋路256番ギル7',
      footer14: 'ソウル金川区加山デジタル1路75-24 10F',
      footer15:
        'お客様の安全な取引のために、現金などでお支払いの際には当モールが加入しているKGイニシスの購入安全サービスをご利用いただけます。',
      company: '会社名',
    },
    plus_admin: {
      pa_001: 'ストア管理',
      pa_002: 'カラー、ロゴなどブランドアイデンティティを反映してサイトに適用してみてください。',
      pa_003: 'ストア情報',
      pa_004: 'ストアカラー',
      pa_005: 'サイトロゴの背景色などに反映されます。',
      pa_006: 'レッド',
      pa_007: 'オレンジ',
      pa_008: 'イエロー',
      pa_009: 'ディープグリーン',
      pa_009_01: 'グリーン',
      pa_010: 'スカイ',
      pa_011: 'マゼンタ',
      pa_012: 'ゴールド',
      pa_013: 'ホワイト',
      pa_014: 'ブラック',
      pa_015: 'ゲーム名',
      pa_016: 'ストア名',
      pa_017: 'ストア紹介',
      pa_018: 'ストアロゴ',
      pa_019:
        '正方形比率の画像ファイルをアップロードしてください。<br/>（画像アップロード : PNG可能 / 最大3MB）',
      pa_020: '登録する',
      pa_021: '削除する',
      pa_022: 'ストアカバー',
      pa_023: 'PC画像',
      pa_024: 'サイズ 3840 x 1280px',
      pa_025: '拡張子JPG、PNG可能',
      pa_026: '最大8MB',
      pa_027: 'PCストアのカバー画像を登録してください。',
      pa_028: 'モバイル画像',
      pa_029: 'モバイルストアのカバー画像を登録してください。',
      pa_030: 'サイズ 1050 x 1960px',
      pa_031: '今すぐ確認する',
      pa_032: '登録する',
      pa_033: 'プロモーションバナーを登録してみてください。',
      pa_034: 'メインバナーの修正',
      pa_035: '基本設定',
      pa_036: '画像バナーURL',
      pa_037: '動画サムネイル画像',
      pa_038: '動画サムネイルを載せてください。',
      pa_039: 'サムネイル画像 : サイズ 1920 x 1080px / JPG, PNG可能 / 最大3MB',
      pa_040: 'アップロード',
      pa_041: '登録する',
      pa_042: 'YouTube URLを入力してください。',
      pa_043: 'プロモーションバナーとして登録する画像または動画ファイルをアップロードしてください。',
      pa_044: '画像',
      pa_045: 'サイズ 1920px x 1080px\nJPG, PNG可能\n最大3MB',
      pa_046: '動画',
      pa_047: '최소 사이즈 710px x 400px<span></span>60초 이하<span></span> ',
      pa_047_1: 'MP4 또는 유튜브 URL 등록 가능<span></span>최대 15MB',
      pa_048: '公開期間設定',
      pa_049: 'ファイル形式が正しくありません。',
      pa_050: '動画の解像度大きさが最小サイズより小さいです。',
      pa_051: '動画の最大長さを超えました。',
      pa_052: '動画ファイルの大きさが最大大きさを超えました。',
      pa_054: '動画アップロードエラー',
      pa_055: 'プロモーションバナーの登録失敗',
      pa_056: '動画バナーはサムネイルが必須です。',
      pa_057: 'バナー公開数上限超過',
      pa_057_01: '動画公開数上限超過',
      pa_058: '公開数が上限を超えました。最大5件まで公開できます。',
      pa_058_01: '公開数が上限を超えました。最大1件まで公開できます。',
      pa_059: '公開数が上限を超えました。バナーの公開ステータスが非公開に登録されます。',
      pa_059_01: '公開数が上限を超えました。動画の公開ステータスが非公開に登録されます。',
      pa_060: 'ドラッグアンドドロップで並び順を変更できます。',
      pa_061: '動画バナータイトル',
      pa_062: '基本設定',
      pa_063: '動画URL',
      pa_064: '動画バナー管理',
      pa_065: '全体動画バナー',
      pa_066:
        'ゲームストアのメインに表示される動画バナーを作り管理してみてください。最大1件まで公開が可能です。',
      pa_067: 'ホーム画面に表示される動画バナーを登録してみてください。',
      pa_068: '動画バナー管理',
      pa_069: '動画バナー登録',
      pa_061_01: '最大37文字まで入力可能です。',
      pa_070: '動画バナー修正',
      pa_071:
        'プロモーションバナーはメインに最大5件まで公開ができます。\n並び順はプロモーションバナー管理＞メイン並び替え変更タブで変更してください。',
      pa_071_01:
        '動画バナーはメインに最大5件まで公開ができます。\n並び順は動画バナー管理＞メイン並び替え変更タブで変更してください。',
      pa_072: 'メタタグ設定',
      pa_073: 'OpenGraphタイトル',
      pa_074: 'OpenGraph内容',
      pa_075: 'OpenGraph画像',
      pa_076: '推奨サイズ(横1200px * 縦600px)',
      pa_077: '登録する',
      pa_078: '企業公式ページURL',
      pa_079: 'Facebook URL',
      pa_080: 'Instagram URL',
      pa_081: 'YouTube URL',
      pa_082: 'Twitter URL',
      pa_016_01: 'カテゴリーストア名',
    },
    checkout: {
      receipt: {
        receipt_01: '口座番号がコピーされました。',
      },
    },
    confirm: {
      ok: 'はい',
      cancel: 'いいえ',
    },
    login: {
      login_01: 'NEXON ESSENTIAL会員登録',
      login_02: 'NEXON ESSENTIAL加入のために<br/>NEXON アカウントメールを登録してください。',
      login_02_01: 'NEXONアカウントメール情報の確認が難しいです。<br/>メール登録後、加入が可能です。',
      login_03: 'メール登録',
      login_04: 'NEXONアカウントにメールアドレスを登録してください。',
      login_05: '本人認証',
      login_06: 'NEXONアカウントに本人認証を完了させてください。',
      login_07: '14歳以上確認',
      login_08: '14歳未満は後見人認証が必要です。',
      login_09: '移動する',
      login_10: 'メール',
      login_11: 'ニックネーム',
      login_12: '携帯電話番号',
      login_13: '利用規約に全て同意',
      login_14: 'NEXON ESSENTIAL利用規約同意（必須）',
      login_15: '個人情報処理方針同意（必須）',
      login_16: 'ゲームおよびサービスの有用なニュースを受け取る（任意）',
      login_17: '見る',
      login_18: 'NEXONログインセッションが期限切れになりました。<br/>もう一度お試しください。',
      login_19: 'ログインが正常に行われませんでした。<br/>もう一度お試しください。',
      login_20: 'NEXONログイン',
      require: {
        title: 'ログイン後、商品をご購入ください。',
        body: '商品はNEXON ESSENTIAL会員のみ購入可能です。',
      },
      login_21: '満14歳未満の児童の個人情報収集',
      login_22: '法定代理人携帯電話認証',
      login_23:
        '（株）ネクソンコリアは以下のように14歳未満の児童の個人情報を収集するために保護者の同意を得ています。<br/>保護者の方は児童の個人情報処理に関する内容を十分に認識した後、同意してください。',
      login_24: '児童の個人情報収集及び利用同意',
      login_25: '保護者の個人情報収集及び利用同意',
      login_26: '商品購入のために<br/>NEXONアカウントメールを登録してください。',
      login_27: 'NEXONアカウントメール情報の確認が難しいです。<br/>メール登録後、購入が可能です。',
      login_28: '他のアカウントでもう一度試してみる',
      login_29:
        '（株）ネクソンコリアが提供するすべてのゲームおよびサービスのアップデート、事前登録、イベント参加など役立つ情報を受け取ることができます。<div style="padding-top: 4px">受信設定状態は[NEXON.com > マイ情報]で確認できます。</div>',
      login_30: 'これからゲームおよびサービスの<br/>有用なニュースを受け取ります。',
      login_31: '{{date}} （株）ネクソンコリア提供',
      login_32:
        '携帯電話認証の過程で「マープルコーポレーション」から認証リクエストが来る場合があります。<br/>「マープルコーポレーション」はNEXON ESSENTIALの公式運営パートナーですので、安心してください。',
      login_32_mobile:
        '携帯電話認証の過程で「マープルコーポレーション」から認証リクエストが来る場合があります。「マープルコーポレーション」はNEXON ESSENTIALの公式運営パートナーですので、安心してください。',
    },
    my_page: {
      is_hidden_user: 'NEXON ESSENTIAL退会する',
      change_profile: 'プロフィール画像が変更されました。',
      delete_profile: 'プロフィール画像が削除されました。',
      marketing_agree_title: '広告性情報の受信に同意する',
      marketing_agree_body: '{{date_time}} 広告性情報の受信に同意しました。',
      marketing_disagree_title: '広告性情報の受信を解除する',
      marketing_disagree_body: '{{date_time}} 広告性情報の受信が解除されました。',
      login_18: '',
      login_19: '',
      login_20: '',
    },
    editorial: {
      related: '関連エディトリアル',
    },
    common: {
      see_more: 'もっと見る',
      close: '閉じる',
    },
    privacy: {
      privacy_child: '児童の個人情報収集及び利用同意',
      privacy_guardian: '保護者の個人情報収集及び利用同意',
    },
    'my-page': {
      main_09: '',
    },
    up_item: {
      logo: '',
    },
    studio: {
      product_guide: {
        title: 'MarppleShop制作配送商品とクリエイター配送商品とは？',
        about_pod: 'MarppleShop制作配送商品',
      },
    },
  },
  '로그인 후 이용해 주세요.': 'ログインしてご利用ください。',
  collection_category: {
    ALL: 'All',
    EXCLUSIVE: 'Exclusive',
    FUNDING: 'Funding',
    All: 'All',
  },
  collection: {
    coll_1_1: 'Description',
    mo_header: 'Collection',
  },
  '개인 정보 수집 및 이용 동의': '個人情報収集·利用同意',
  customer_order: {
    receipt_info: '領収書を表示',
    receipt: {
      card: 'カード領収書',
      cash: '現金領収書',
      purchase: '購入領収書',
      id: '購入番号',
      paid_at: '取引日時',
      provider: '決済代行会社',
      orderer: '購入者名',
      products: '商品名',
      price: '金額',
      pdf: 'PDFで保存',
      print: '印刷',
      total_price_t: '承認金額',
      cancel_price_t: '取消金額',
      up_c_id: '商品番号',
      supply_price_t: '供給価格',
      vat_price_t: 'VAT',
      result_price_t: '合計',
      'change-warn': '決済情報が修正されました。<br>確認のためカスタマーセンターにご連絡ください。',
      detail: {
        card_title: 'カード領収書（売上伝票）',
        cash_title: '領収書',
        card_name: 'カード名',
        apply_num: '承認番号',
        paid_at: '決済日',
        card_num: 'カード番号',
        card_info: 'カード会社情報',
        seller_info: '販売者情報',
        seller_name: '商号',
        seller_ceo: '代表者名',
        seller_num: '事業者登録番号',
        seller_tel: '電話番号',
        seller_address: '事業所住所',
        provider_info: '加盟店情報',
        provider_name: '加盟店名',
        provider_tel: '加盟店番号',
        provider_address: '住所',
        cancel_info: '取消された決済です。',
        card_quota: '取引種別/分割払い',
        product_classification: '区分',
      },
      canceled: '取消領収書',
      header_title: '領収書発行履歴',
      paid_at_title: '注文日',
      purchase_info: '購入情報',
      cash_cancel: '',
      cannot_print_mo: '領収書の印刷はPCで可能です',
    },
    contents: {
      list_description: 'あなたが気に入りそうなものを持ってきました 💘',
    },
  },
  error: {
    desc404:
      'お探しのページのアドレスが間違って入力されているか、<br/>アドレスの変更または削除により接続できません。<br/>入力したページのアドレスが正確であるかもう一度確認してください。',
    desc500:
      'サービスのご利用にご不便をおかけして申し訳ございません。<br/>一時的にサーバーで問題が発生しました。<br/>しばらくしてからもう一度お試しください。',
  },
  tpl_faq: {
    group_1_label: '注文/配送',
    group_1_q1: '注文後、商品受け取りまでどのくらいかかりますか？',
    group_1_a1:
      'ご注文いただいた商品は3日以内に出荷が開始される予定です。物流状況により配送が遅延する場合がありますことをご了承ください。',
    group_1_q2: '注文状況はどのように確認できますか？',
    group_1_a2:
      'ログイン > マイページ > 購入履歴で注文に関する進行状態及び配送日程を確認することができます。<br/><br/>ご注文いただいた商品の進行過程は次の通りです。<br/>[制作準備中/商品準備中]：決済が完了し、商品を準備している段階です。<br/>[制作中]：ご注文いただいた商品が制作されている段階です。<br/>[配送準備中]：制作が完了し、商品の検査及び梱包を行っています。<br/>[配送中]：ご注文いただいた商品が出荷され、配送会社に引き渡された状態であり、運送状番号はテキストメッセージで送信されます。出荷翌日から送り状番号照会による配送状況の確認が可能です。<br/>[配送完了]：配送が完了した状態です。',
    group_1_q3: '非会員も注文できますか？',
    group_1_a3:
      'NEXON ESSENTIALはNEXON会員の場合のみ注文することができます。<br/>NEXON会員にご登録の上、サービスをご利用ください。NEXON会員になると、NEXON ESSENTIALでの注文はもちろん、様々なイベントや特典も受けることができます。',
    group_2_label: '交換/返金',
    group_2_q1: '注文をキャンセルすることはできますか？',
    group_2_a1:
      '特定の段階までは、マイページ > 購入履歴 > 詳細で会員が直接注文キャンセルすることができます。<br/>ㆍ <b>[注文受付 / 制作準備中]</b>の段階までは、会員が直接注文キャンセルすることができます。<br/>ㆍ <b>[制作中 / 商品準備中]</b>の段階からは、会員の直接注文キャンセルはできません。カスタマーセンターまたはEメールでの一対一のお問い合わせでリクエストしてください。<br/>ㆍ 例外として、注文製作商品の場合、単純な気持ちの変化による注文キャンセルや交換・返品は難しいです。<br/>ㆍ 注文キャンセルに関する内容はFAQのキャンセル/返金で確認できます。<br/>※ NEXON ESSENTIALは使用する商品のみを生産することで、無駄のない生産により資源の無駄を防ぎ、環境に配慮しています。慎重な購入をお願いします。',
    group_2_q2: '商品を受け取った後、交換や返金は可能ですか？',
    group_2_a2:
      '交換/返品リクエスト可能期間は、商品の開封及び破損なしに、配送完了後7日以内の場合のみ返金が可能です。<br />\n     例外として、カスタムオーダー商品の場合、単純な気持ちの変化による注文キャンセル/交換/返品は難しいです。<br />\n     ただし、受け取った商品に不良がある場合や誤配送された場合には、30日以内にカスタマーセンターまたはEメール、1:1お問い合わせで連絡いただければ、交換及び返品返金が可能です。<br />\n     交換/返品申請はカスタマーセンターまたはEメールで受け付けていただければ、配送会社への返品受付をサポートします。<br />\n     返品フォームに記入して商品と一緒に梱包してください。（返品フォームが欠けている場合、返金が遅延する可能性があります。）他の配送会社や任意で荷物を送ると、返送される可能性があり、紛失及び受付漏れにより返金が遅延したり不可能になったりする場合があります。<br /><br />\n     \n     返品/交換ができない場合<br />\n     ㆍ カスタムオーダー商品の場合<br />\n     ㆍ 返品リクエスト期間が過ぎた場合<br />\n     ㆍ 購入者の責任ある理由で商品などが破損または滅失した場合<br />\n     ㆍ 購入者の責任ある理由で包装が破損し、商品価値が著しく喪失した場合（例：食品、化粧品、香水類、音楽ソフト、電子製品など）<br />\n     ㆍ 購入者の使用または一部消費により商品の価値が著しく減少した場合（ラベル除去、タグ除去など）<br />\n     ㆍ 商品告知内容と相違、契約内容と異なる履行の場合、商品受領後3ヶ月以内または表示/広告と異なる事実を知った日から30日以内のどちらか一方が経過すると返品/交換不可<br />\n     ㆍ 複製可能な商品などの包装を破損した場合（例：CD/DVD/GAME/書籍の場合、包装開封時）',
  },
  faq: {
    group_1_label: '注文/配送',
    group_1_q1: '注文後、商品受け取りまでどのくらいかかりますか？',
    group_1_a1:
      'この商品は注文製作商品です。注文製作商品は1週間の注文を集めて翌週に生産・配送する方式で運営されています。そのため、注文後、商品が発送されるまでには一定期間が必要であり、配送状況に応じてお客様に個別にご案内しております。注文後、商品受け取りまで最低1週間以上かかる場合がありますことをご了承ください。',
    group_1_q2: '注文状況はどのように確認できますか？',
    group_1_a2:
      'ログイン > マイページ > 購入履歴で注文に関する進行状態及び配送日程を確認することができます。<br/><br/>ご注文いただいた商品の進行過程は次の通りです。<br/>[制作準備中/商品準備中]：決済が完了し、商品を準備している段階です。<br/>[制作中]：ご注文いただいた商品が制作されている段階です。<br/>[配送準備中]：制作が完了し、商品の検査及び梱包を行っています。<br/>[配送中]：ご注文いただいた商品が出荷され、配送会社に引き渡された状態であり、運送状番号はテキストメッセージで送信されます。出荷翌日から送り状番号照会による配送状況の確認が可能です。<br/>[配送完了]：配送が完了した状態です。',
    group_1_q3: '非会員も注文できますか？',
    group_1_a3:
      'NEXON ESSENTIALはNEXON会員の場合のみ注文することができます。<br/>NEXON会員にご登録の上、サービスをご利用ください。NEXON会員になると、NEXON ESSENTIALでの注文はもちろん、様々なイベントや特典も受けることができます。',
    group_2_label: '交換/返金',
    group_2_q1: '注文をキャンセルすることはできますか？',
    group_2_a1:
      '特定の段階までは、マイページ > 購入履歴 > 詳細で会員が直接注文キャンセルすることができます。<br/>ㆍ [注文受付 / 制作準備中]の段階までは、会員が直接注文キャンセルすることができます。<br/>ㆍ [制作中 / 商品準備中]の段階からは、会員の直接注文キャンセルはできません。カスタマーセンターまたはEメールでの一対一のお問い合わせでリクエストしてください。<br/>ㆍ 例外として、注文製作商品の場合、単純な気持ちの変化による注文キャンセルや交換・返品は難しいです。<br/>ㆍ 注文キャンセルに関する内容はFAQのキャンセル/返金で確認できます。<br/>※ NEXON ESSENTIALは使用する商品のみを生産することで、無駄のない生産により資源の無駄を防ぎ、環境に配慮しています。慎重な購入をお願いします。',
    group_2_q2: '商品を受け取った後、交換や返金は可能ですか？',
    group_2_a2:
      '交換/返品リクエスト可能期間は、商品の開封及び破損なしに、配送完了後7日以内の場合のみ返金が可能です。<br />\n      例外として、カスタムオーダー商品の場合、単純な気持ちの変化による注文キャンセル/交換/返品は難しいです。<br />\n      ただし、受け取った商品に不良がある場合や誤配送された場合には、30日以内にカスタマーセンターまたはEメール、1:1お問い合わせで連絡いただければ、交換及び返品返金が可能です。<br />\n      交換/返品申請はカスタマーセンターまたはEメールで受け付けていただければ、配送会社への返品受付をサポートします。<br />\n      返品フォームに記入して商品と一緒に梱包してください。（返品フォームが欠けている場合、返金が遅延する可能性があります。）他の配送会社や任意で荷物を送ると、返送される可能性があり、紛失及び受付漏れにより返金が遅延したり不可能になったりする場合があります。<br /><br />\n      \n      返品/交換ができない場合<br />\n      ㆍ カスタムオーダー商品の場合<br />\n      ㆍ 返品リクエスト期間が過ぎた場合<br />\n      ㆍ 購入者の責任ある理由で商品などが破損または滅失した場合<br />\n      ㆍ 購入者の責任ある理由で包装が破損し、商品価値が著しく喪失した場合（例：食品、化粧品、香水類、音楽ソフト、電子製品など）<br />\n      ㆍ 購入者の使用または一部消費により商品の価値が著しく減少した場合（ラベル除去、タグ除去など）<br />\n      ㆍ 商品告知内容と相違、契約内容と異なる履行の場合、商品受領後3ヶ月以内または表示/広告と異なる事実を知った日から30日以内のどちらか一方が経過すると返品/交換不可<br />\n      ㆍ 複製可能な商品などの包装を破損した場合（例：CD/DVD/GAME/書籍の場合、包装開封時）',
  },
  mps2: {
    common: {
      price: '¥{{price}}',
      word_length: '{{length}}文字',
      reset: '初期化',
      remove_all: '全て削除',
      error_title: 'エラー',
      error_message: 'エラーが発生しました。もう一度お試しください。',
      agree: '同意',
      disagree: '同意しない',
      confirm: '確認',
      cancel: 'キャンセル',
      start: 'スタート',
      close: '閉じる',
      see_more: 'もっと見る',
      leave: '退出',
      delete: '削除する',
      update: 'アップデート',
      go_marppleshop: 'MarppleShopへ移動',
      example: 'ex',
      category: {
        level_1: {
          goods: 'グッズ',
          ebook: '電子書籍',
          brand_deal: 'ブランドディール',
          handmade: 'ハンドメイド',
        },
      },
    },
    footer: {
      마플코퍼레이션: 'Marpple Corporation',
      '마플샵 크리에이터': 'MarppleShopクリエイター',
      '마플샵 플러스': 'MarppleShopプラス',
      '마플샵 팝업스토어': 'Online Pop-up',
      '온라인 팝업스토어': 'オンラインポップアップ',
      '오프라인 팝업스토어': 'オフラインポップアップ',
      '브랜드 커머스': 'ブランドコマース',
      '유튜브 쇼핑': 'YouTubeショッピング',
      '핸드메이드 크리에이터': 'ハンドメイドクリエイター',
      '커머스 크리에이터': 'コマースクリエイター',
      '굿즈 파트너스': 'グッズパートナーズ',
      고객센터: 'カスタマーサービス',
      신고센터: '申告センター',
      이용약관: '利用規約',
      개인정보처리방침: '個人情報処理方針',
      privacy_charge: '個人情報保護責任者',
      privacy_charge_name: '유인동',
      customer_center_info: '平日 10:00 ~ 18:00',
      inicis_info: 'KGイニシスを通じて現金決済の際、当社が加入している購入安全サービスをご利用いただけます。',
      inicis_button: 'KGイニシス加入確認',
      notice:
        'クリエイター発送商品、デジタル・電子書籍商品については、株式会社Mapple Corporationは通信販売仲介業者であり、通信販売の当事者ではありません。商品の注文、配送、返金などに関する義務と責任は各販売者にあります。',
      business_info: '事業者情報',
      '마플샵 오프라인 팝업스토어': 'Offline Pop-up',
      '마플샵 브랜드 커머스': 'Brand Commerce',
      '마플샵 X 유튜브 쇼핑': 'MarppleShop X Youtube',
      terms_paid_service: '統合有料サービス利用規約',
      customer_support: 'カスタマーサポート',
      faq: 'よくある質問',
      inquiry: '1:1 お問い合わせ',
    },
    product: {
      title: 'Products',
      sub_title: 'MarppleShopの商品をご紹介します！',
      limited: '限定版',
      best: 'ベスト',
      all_products: '全商品',
      all: '全体',
      only_stock_available: '品切れ商品除外',
      product_01: '{{count}}個の特別さを購入する時間！',
      product_02: '最近はこんなグッズがよく売れています 😎',
      total: '総',
      count: '個の商品',
      price: '価格',
      badge: {
        sold_out: '売り切れ', // 또는 '完売'
        limited: '限定',
        closed: '終了',
        nft: 'NFT',
        stock_left: '残り{{stock}}点',
        upcoming: '開催予定',
        period_limited_second: '{{second}}秒',
        period_limited_minute: '{{minute}}分',
        period_limited_hour: '{{hour}}時間',
        period_limited_day: '{{day}}日',
        membership: '会員限定',
        trending: '急上昇',
        popular: '人気',
        brand_deal: 'ブランドディール',
        funding: 'ファンディング',
      },
      tag: {
        sold_out: '売り切れ',
        period_limited_day: '残り{{day}}日',
        period_limited: '締切{{time}}前',
        quantity_limited: '残り{{stock}}個',
        upcoming_soon: 'もうすぐ発売',
        upcoming_min: '発売{{minute}}分前',
        upcoming_hour: '発売{{hour}}時間前',
        upcoming_day: '発売{{day}}日前',
        upcoming: '発売予定',
        realtime: '{{time}}前に売れました！',
        realtime_compact: '{{time}}前に販売',
      },
      sort: {
        popular: '人気順',
        newest: '新規登録順',
        price_high_to_low: '価格が高い順',
        price_low_to_high: '価格が安い順',
        many_reviews: 'レビュー件数順',
        featured: '推薦順',
      },
      filter: {
        title: '商品フィルター',
        is_limited: '限定版のみ表示',
        is_limited_short: '限定のみ表示',
        without_sold_out: '品切れ商品除外',
        without_sold_out_short: '品切れ除外',
        confirm: '商品を見る',
        info: '商品情報',
        style: 'スタイル',
      },
      empty: {
        shop_title: 'ご希望の条件に合う商品がありません。',
        shop_body: '他の条件で商品を探してみてください！',
        plus_shop_body: '{{name}}で商品をご用意しています！',
        creator_title: '商品を準備中です。',
        creator_body: 'クリエイターが商品を準備している間に、<br />MarppleShopの様々な商品を見てみませんか？',
        creator_footer: '商品を見に行く',
        title: 'ご希望の条件に合う商品がありません。',
        description: '他の条件で商品を探してみてください！',
      },
      recommend: 'おすすめ商品',
      weekly_banner_title: '週間ベストTOP100',
      weekly_banner_desc: '今週、最も人気のある商品をご覧ください！',
      monthly_banner_title: '月間ベストTOP100',
      monthly_banner_desc: '今月、最も人気のある商品をご覧ください！',
    },
    recently_sold: {
      sold_now: 'ただ今売れた',
      title: 'ただ今売れた',
      sub_title: '今売れてる！話題急上昇中のトレンド商品！',
      desc: '今売れた\n話題の商品を\nチェック！',
    },
    creator: {
      creator_01: 'クリエイター',
      creator_02: 'あなたの心を盗みに来た',
      plus: {
        description: 'ファン心で見て、私心で買う公式グッズ',
        tooltip:
          'MarppleShop Plusは、様々なクリエイターを保有している企業と\nブランドのための統合<b><u>IPコマースソリューション</u></b>です。\nプラットフォーム構築から商品製作、注文、生産、配送まで\n簡単にIPコマースプラットフォームを構築してみてください！',
        tooltip_link: 'MarppleShop Plus申し込む',
        see_more: 'MarppleShop Plus全体を見る',
        filter: {
          recommendation: '推薦順',
          new: '新規登録順',
          popular: '人気順',
          like: 'いいね順',
          review: 'レビュー件数順',
        },
      },
      ranking: {
        header_title: 'Creator Ranking',
        page_title: '人気のクリエーターランキング',
        month: 'yy年MM月',
        week: '{{year_month}} 第{{week}}週目',
        period: '{{date}}',
        empty_title: 'クリエイターの商品はすべて売り切れました！',
        empty_desc:
          '好きなクリエイターを応援して、新しく発売される<br/>クリエイター商品をチェックしましょう！',
        empty_btn: '応援しに行く',
      },
      txt1: 'クリエイター紹介',
      description_empty: 'クリエイターが紹介文を準備しています。',
      view: {
        description: 'クリエイターが直接聞かせてくれる話',
      },
      all: {
        description: '世の中のすべてのクリエイターがここに！',
        see_more: 'もっと見る',
      },
      empty_title: 'クリエイターたちがオープンの準備中です！',
      see_more: 'もっと見る',
      share: 'マイプロショップで{{name}}だけのグッズに出会ってください。',
    },
    modal: {
      취소: 'キャンセル',
      확인: '確認',
      저장: '完了',
    },
    review: {
      title: 'レビュー',
      thanktyou_title: 'レビューが正常に登録されました。',
      thanktyou_desc: '作成したレビューはマイページ>私のレビューで確認できます。',
      page_title: 'フォトレビュー',
      page_sub_title: 'MarppleShop リアルレビュー',
      page_sub_title__plus: 'ファンたちの話が気になる時',
      option: 'オプション',
      write_place_holder:
        'クリエイターを応援するレビューを登録すると、審査後に最大300Pを付与します。\nクリエイターにも最大{{order_point}}Pの作品活動支援金を差し上げます。',
      delete: '削除',
      sns_review: 'SNS レビュー',
      comment_count: 'コメント&nbsp;<span class="article-detail-comments__count">{{count}}</span>個',
      empty_title: '最初のレビューの主人公になってみてください！',
      empty_title_desc:
        '真心のこもったレビューは、クリエイターにとって大きな力になります。<br />レビューを登録し、ポイントをゲットしてください！',
    },
    breadcrumbs: {
      home: 'ホーム',
      creator_ranking: 'クリエイターランキング',
      product_ranking: '商品ランキング',
      detail: '詳細',
    },
    main: {
      quick_menus: {
        creator_apply: 'クリエイター申請',
        goods_partner: 'グッズパートナーズ申請',
        fee_0: 'ハンドメイドなら手数料0％',
        weekly_ranking: '今週のクリエイターランキング',
        realtime_review: 'リアルタイムレビュー',
        //
        fall_base_ball: '秋はやっぱり野球',
        domiworld: 'ドミーワールド',
        how_to_record: '記録、こうするだけで大丈夫',
        september_hot: '9月、暑い人たちの協会',
        book_season: '本を読もう！今がぴったりの季節',
        attention_graduate_student: '大学院生！注目！',

        treasure_shop: '宝物賞',

        order_now_cool: '今させて選ぶとき',
        chuseok_nagging: 'チュソクの叫び声、愉快な反乱',

        trust_tshirt: 'このTシャツ、信じますか？',
        love_potery: '詩の魅力に陥る',
        shampoo_picture: '図からシャンプーの香り',

        say_nothing: 'ひとことが稼ぎになる',
        room_change: '部屋の雰囲気を変えて',
        dajai_yusanmu: '人間失格グッズ合格、太宰有無',

        help_marppleshop: '100万ウォン稼いだら',
        //
        popup_store: 'MarppleShopポップアップストア',
        popular: '人気クリエイター',
        best_ranking: 'ベストランキング',
        photo_review: 'フォトレビュー',
        plus_apply: 'MarppleShop Plus申し込む',
        youtube: 'Youtube Shopping X MarppleShop',
        CCC: 'Creator Club',
        popup_store_mo: 'オンラインポップアップ',
        popular_mo: '人気クリエイター',
        best_ranking_mo: 'ベストランキング',
        creator_apply_mo: 'クリエイター申請',
        photo_review_mo: 'フォトレビュー',
        plus_apply_mo: 'MarppleShop Plus',
        youtube_mo: 'Youtube Shopping',
        CCC_mo: 'Creator Club',
        curation: 'キュレーション',
        realtime: 'ただ今売れた',
        product_ranking: '人気急上昇',
        limited: '限定商品',
        funding_apply: 'MarppleShopファンディングに申し込む',
        product_curation: 'キュレーション',
        handmade_creator: 'ハンドメイド',
        online_popup_store: 'ポップアップ',
      },
      creator_ranking: {
        title: 'リアルタイムクリエイターランキング',
        title_mobile: 'リアルタイムクリエイターランキング',
        description: '多彩なクリエイターの魅力が炸裂！',
        updated_at: '{{minute}}分前に更新',
        statistics_date: '{{date}} 集計',
        see_more: 'もっと見る',
        item: {
          title: 'クリエイターの商品はすべて完売しました！',
          sub_title: 'お気に入りのクリエイターを応援して、\n新しく発売される商品を狙いましょう！',
          fan_letter: 'ファンレターを書きに行く',
        },
      },
      limited_edition: {
        description: '{{count_text}}個の特別さを購入する時間！',
        title: '限定商品ランキング',
        sub_title: '今だけの{{count_text}}個の特別アイテム',
      },
      weekly_best_product: {
        description: '最も人気のある商品をご覧ください！',
      },
      cast_on_air: {
        description: '推しはただいま営業中',
      },
      photo_review: {
        description: 'MarppleShop リアルレビュー',
      },
      new_creator: {
        description: 'MarppleShopホットデビュー！',
      },
      lifestyle_curation: {
        description: 'この世の多様な好みのために',
      },
      store_direct: '{{name}} ショップ 今すぐ見る',
      popup: {
        description: 'ただMarppleShopでのみ会える',
        title: 'MARPPLESHOP POP-UP STORE',
        percent: '達成',
        button: 'ポップアップ全体',
      },
      creators: {
        description: 'あなたの心を盗みに来た',
      },
      contents: {
        description: '興味ありそうなもの 💘',
      },
      best_product: {
        description: '最近はこんなグッズがよく売れています 😎',
      },
      top_100: {
        title: '人気商品トップ100',
        title_mo: '人気商品',
        sub_title: 'どの商品が最も売れたでしょうか？',
        see_more: '<span>グッズ TOP 100</span>もっと見る',
      },
      category_product_ranking: {
        title: 'カテゴリーランキング',
        sub_title: '今、反応が熱い商品に出会ってみてください！',
        tooltip:
          'カテゴリー別商品ランキングはMarppleShopで\n一週間で最も人気のある商品をカテゴリー別に\n区分して提供します。',
        empty_title: 'ランキング集計中です！',
        empty_description_mo: '他のカテゴリを選択するか、\n検索で商品を探してみてください！',
        empty_description_pc: '他のカテゴリを選択するか、検索で商品を探してみてください！',
      },
      realtime: {
        title: '今売れた商品',
        title_mo: 'たった今販売された人気商品！',
        sub_title: '他の人はどんなものを購入するのでしょうか？',
      },
      brand_commerce: {
        title: 'クリエイター X ブランド商品',
        sub_title: '一緒に集まって作るより大きな幸せ！',
        tooltip:
          'クリエイター×ブランド商品は、\nクリエイターとブランドが協力して\n商品をPRし、手頃な価格で提供します！',
      },
      new_creator_ranking: {
        title: '今月の新クリエイター',
        sub_title: '新しい感覚、フレッシュなアイデア！',
        tooltip:
          '今月の新人クリエイターランキングでは、\nこの一週間でマープルショップに新たに登場したクリエイターの中から、\n最も注目を集めている人気クリエイターをご紹介いたします。',
      },
      funding_title: '注目すべきファンディング',
    },
    mypage: {
      question: {
        commission: {
          title: '',
          name: '',
          number: '',
          check: '',
          button: '',
          button_studio: '',
        },
        '문의 내용': '問議内容',
        제목: 'タイトル',
        내용: '内容',
        첨부파일: '必要書類',
        '답변 내용': '回答内容',
        before_answer_content: 'クリエイターの回答が登録されていません。',
        '답변 대기': '回答待ち',
        '답변 완료': '回答完了',
        '추가 문의 내용': '追加お問い合わせ内容',
        '추가 답변 완료': '追加回答完了',
        add_question: '追加問い合わせ',
        add_answer: '追加回答完了',
        shop_name: 'ショップ',
        product_name: '商品名',
        empty_title: '問い合わせ履歴はありません。',
        empty_desc:
          'クリエイターへの問い合わせは、商品詳細ページ &gt; 購入案内または購入履歴詳細ページから行えます。',
        '최근 1년간 문의 내역만 확인 가능합니다.': '最近1年間の問い合わせ履歴のみ確認できます。',
        product_num: '商品番号',
        do_add_question: '追加問い合わせ',
        do_end_question: '問い合わせ終了',
        'JPG, JPEG, PNG, ZIP, PDF 가능 | 최대 10MB': 'JPG、JPEG、PNG、ZIP、PDF対応 | 最大10MB',
      },
      no_like_creator_title: 'いいねしたクリエイターがいません。',
      no_like_creator_title_desc: '好きなクリエイターにいいねを押してみてください。',
      no_like_product_title: 'いいねした商品がありません。',
      no_like_product_title_desc: '自分の好みの商品にいいねを押してみてください。',
      order_deliver: '注文·配送',
      written_review: 'マイレビュー',
      liked_products: 'いいね',
      '이름을 입력해 주세요': 'お名前を入力してください。',
      '앱 설정': 'アプリ設定',
      app_setting: 'アプリ設定',
      creator_apply: 'クリエイティブであるなら、<b>あなたもMarppleShopのクリエイター！</b>',
      creator_apply_mo: '申し込み',
      creator_apply_mobile: '自分の創造性で',
      logout: 'ログアウト',
      marppleshop: '想像するすべてが現実になるMarppleShop',
      order: {
        title: '購入履歴',
      },
      review: {
        title: '私が書いた文章',
        empty_title: '作成したレビューがありません。',
        empty_desc: '好きなクリエーターの商品を購入して<br />最初のレビューを残してみてください！',
      },
      like: {
        title: 'いいね',
        empty_product_title: 'いいねした商品がありません。',
        empty_creator_title: 'いいねしたクリエイターがいません。',
        empty_product_desc: '自分の好みの商品にいいねを押してみてください。',
        empty_creator_desc: '好きなクリエイターにいいねを押してみてください。',
      },
      recent: {
        title: '最近見た',
        empty_product_title: '最近見た商品がありません。',
        empty_creator_title: '最近見たクリエイターがいません。',
        empty_product_desc: 'MarppleShopで新しいお気に入りを見つけてみましょう！',
        empty_creator_desc: 'MarppleShopで気に入ったクリエイターを探してみてください！',
        empty_product_find: '商品を見に行く',
        empty_creator_find: 'クリエイター探し',
        product: ' 상품 <span class="count">{{count}}</span>',
        creator: ' 크리에이터 <span class="count">{{count}}</span>',
      },
      creator_question: {
        title: 'クリエイター問い合わせ履歴',
      },
      creator_apply_prefix: 'クリエイティブであるなら、',
      creator_apply_suffix: 'あなたもMarppleShopのクリエイター！',
      funding_apply_prefix: 'ファンディング目標を達成したら',
      funding_apply_suffix: 'Pop-up 開催を全面サポート。',
    },
    popup_store: {
      rate: '{{rate}} 目標達成',
      total: '総販売金額 ¥{{price}}',
      status: {
        closed: '閉店',
      },
      tooltip:
        'MarppleShopポップアップストアはMarppleShopと<br />クリエイターが一緒に商品を企画して製作し<br />お客様に披露するサービスです。',
      tooltip_link: 'MarppleShop Pop-up Store 申し込む',
      archived: {
        sub_title: 'MarppleShopポップアップアーカイブ',
        group_label: '{{year}}年{{month}}月',
        title: 'MarppleShopポップアップアーカイブ',
      },
      now: {
        sub_title: '現在開催中のMarppleShopポップアップ',
        go_upcoming: '開催予定のポップアップ',
        title: '現在開催中のMarppleShopポップアップ',
      },
      upcoming: {
        sub_title: '開催予定のポップアップストア',
        openrun_btn: 'オープンラン申し込み',
        go_now: '開催中のポップアップ',
        title: '現在開催中のMarppleShopポップアップ',
      },
      openrun_modal: {
        title: 'オープンラン申し込み',
        name_label: 'ポップアップストア名',
        alarm_label: '通知選択',
        email_label: 'メール',
        email_holder: 'メールを入力してください。',
        valid_email: 'メールを入力してください。',
        valid_email2: '正しいメール形式で作成してください。',
        alert_title: 'オープンラン申し込み完了',
        alert_msg:
          'ポップアップストアのオープン24時間前と30分前にメールが送信されます。\nわくわくする気持ちでお待ちください！',
        notice_li_1: 'オープン通知は該当ポップアップストアの24時間前と30分前に送信されます。',
        notice_li_2: '広告情報受信設定に同意していただいてから通知申し込みが可能です。',
        notice_li_3: '一部ポップアップストアはリリースの延期や状況によってオープンが遅れる場合があります。',
        cancel_btn: 'キャンセル',
        confirm_btn: '通知申請',
      },
      empty: {
        upcoming_title: 'ワクワクするポップアップストアを準備中です！',
        now_title: '進行中のポップアップストアはありません。',
        archived_title: '進行中のポップアップストアはありません。',
        desc: 'より多様な好みに応えるためにポップアップストアを準備しています。',
        last_popups: '過去のポップアップ',
        see_more: 'See More',
      },
    },
    login: {
      email_placeholder: 'メールアドレス',
      password_placeholder: 'パスワード',
      login: 'ログイン',
      find_id: 'ID検索',
      reset_password: 'パスワードの再設定',
      invalid: 'ログイン失敗',
      invalid_description:
        'メールアドレスまたはパスワードが正しくありません。<br>入力した情報をもう一度確認してください。',
      need_login: {
        title: 'ログインのご案内',
        message: 'ログインが必要です。<br/>MarppleShopにログインして自分の好みを見つけてみてください！',
      },
      email_verify_sent: '登録時に作成されたメールアドレスに認証メールを送信しました。',
      check_email: 'メールボックスをもう一度確認してください。',
      resend_email: '認証メールの再送信',
      change_email: 'メールの変更',
      email_send_ing: 'メール送信中',
      email_error: 'メールエラー',
      loading_title: '少々お待ちください！',
      loading_guide: 'リクエストされたページに移動中です。',
      error_title: 'ログイン中にエラーが発生しました。',
      error_guide: 'しばらくしてからもう一度お試しいただくか、<br/>サポートチームにお問い合わせください。',
      cs: 'カスタマーサポート',
      go_main: 'メインへ移動',
      try_later: '後でお試し',
      go_retry: '再試行',
      creator_login_error_title: '別のアカウントでリンクを再クリックしてください。',
    },
    contents: {
      list_description: '興味ありそうなもの 💘',
    },
    purchase_card: {
      title: '購入認証カード',
      creator_purchase_info_description:
        '<span><b>{{order}}番目</b>に</span><span>購入したファンです！</span>',
      creator_purchase_card_info_description_1: '特別な瞬間を込めた',
      creator_purchase_card_info_description_2: '認証カードが準備されています！',
      download_medium: 'カードのダウンロード',
      download_small: 'カタカナ',
      download_success: '購入認証カードが保存されました。',
      download: '{{store}}_MarppleShop_購入認証カード',
      konva: {
        purchased_at: '購入日',
        count: '購入数量',
      },
      status: {
        purchase: '購入完了',
        before_purchase: '入金待ち',
      },
    },
    signup: {
      name_placeholder: 'お名前を入力してください。',
      email_placeholder: 'メールを入力してください。',
      password_placeholder: 'ログイン時に使用するパスワードを入力してください。',
      email_invalid_message: '正しいメール形式で作成してください。',
      password_short_message: '10文字以上',
      password_invalid_message: '英文、数字、特殊文字を含む',
      signup: '会員登録',
      all_check_label: '全体同意',
      terms_check_label: '利用約款同意',
      privacy_check_label: '個人情報の収集及び利用に関する同意',
      age_check_label: '14歳以上です。',
      ad_check_label: '広告情報の受信同意(選択)',
      more: '見る',
      data_error: '検証されていないデータ',
      data_error_message:
        '予期しないエラーにより登録できません。<br>同じ問題が繰り返し発生した場合<br><a href="malito:cs@marppleshop.com" style="text-decoration-line: underline">cs@marppleshop.com</a> までお問い合わせください。',
      data_valid_error: '入力情報エラー',
      data_valid_error_message:
        '有効なメールアドレスではないか、形式が正しくありません。または、名前が入力されていないか、特殊文字が含まれているか確認してください。',
      check_error: '約款同意確認',
      check_error_message: '登録のために約款に同意してください。',
      email_duplicated: 'メール重複',
      email_duplicated_message: '既に登録済みのメールです。<br>既存のメールでログインしてください。',
      resend: '再送',
      email_verify: 'メール認証する',
      email_verify_message:
        '認証メールを送信しました。<br>メール確認後、認証するボタンをクリックすると<br>会員登録認証が完了します。',
      email_verify_resend: '認証メール再送信',
      email_verify_resend_message:
        '認証メールを再送信しました。<br>数分間到着しなければ<br>迷惑メールフォルダをご確認ください。',
      email_verify_resend_fail: '認証メール再送信失敗',
      email_verify_resend_fail_message: 'リクエスト失敗。再度お試しください。',
      welcome: 'お会いできて嬉しいです！',
      welcome_message:
        'MCO統合アカウントの登録が完了しました。<br/>想像するすべてが現実になるMarppleShopで<br/>自分だけのスタイルを見つけに行きましょう！',
      welcome_label: '始める',
      consecutive_char_error: 'パスワード使用不可',
      consecutive_char_error_message: 'パスワードに連続した文字または数字は<br>使用できません。',
      email_password_error: 'パスワード使用不可',
      email_password_error_message: 'パスワードに入力されたメールと<br>同じ文字は使用できません。',
      invalid_password_error: 'パスワード使用不可',
      invalid_password_error_message:
        'パスワードは10文字以上で、英字、数字、特殊文字をすべて含める必要があります。',
      to_login: 'ログイン',
      close: '閉じる',
      welcome_message_sns_connect:
        'MCO統合アカウントの接続が完了しました。<br/>想像するすべてが現実になるMarppleShopで<br/>自分だけのスタイルを見つけに行きましょう！',
    },
    curation: {
      page_description: '商品をご紹介します！',
      page_sub_title: 'この世の多様な好みのために',
    },
    creator_view: {
      page_sub_title: 'クリエイターが直接聞かせてくれる話',
    },
    reset_password: {
      title: 'パスワードの再設定',
      email: 'メール',
      email_placeholder: 'メールを入力してください。',
      request_change_email: 'パスワード変更のメール受信',
      send_title: 'パスワード変更のメール送信',
      send_message:
        'パスワードをリセットするためのメールを送信しました。<br/>メールが届かなかった場合は、<br/>迷惑メールフォルダを確認してください。',
      error_title: 'パスワード再設定不可',
      error_no_email: 'パスワード再設定のメールが送信できません。<br/>メールアドレスをご確認ください。',
      change: 'パスワード変更',
      new_password: '新しいパスワード',
      new_password_placeholder: '新しいパスワードを入力してください。',
      error_new_password_length: '10文字以上',
      error_new_password_valid: '英文、数字、特殊文字を含む',
      new_password_check: '新しいパスワード確認',
      new_password_check_placeholder: '新しいパスワードを再入力してください。',
      new_password_check_valid: 'パスワード一致',
      error_no_password: 'パスワードが空です。',
      error_no_password_check: 'パスワードの確認が空です。',
      error_password_no_equal: 'パスワードが一致しません。',
      error_code_invalid: '認証コードが無効です。',
      error_no_user: '入力された情報に一致するアカウントがありません。',
      error_current_password_same: '前のパスワードと同じパスワードは使用できません。',
      success_title: 'パスワード再設定完了',
      success_message: 'パスワードが変更されました。',
    },
    cart: {
      title: 'カート',
      check_cart: 'カートを確認する',
      change: '変更',
      option_changed: '商品をもう一度カートに入れてください。（オプション購入不可）',
      no_stock: '商品をもう一度ご確認ください。（商品またはオプションの品切れ）',
      not_enough_stock: '商品をもう一度カートに入れてください。（在庫不足）',
      discontinued: '商品が購入できない状態です。（商品またはオプションの売り切れ）',
      empty_title: 'カートが空いています！',
      empty_desc: '様々な商品を見て<br/>自分に合う商品を入れてみてください！',
    },
    search: {
      all: '全体',
      product: '商品',
      goods: '',
      handmade: '',
      brand_deal: '',
      ebook: '',
      review: '',
      plus_shop: 'プラスショップ',
      creator: 'クリエイター',
      popup_store: 'ポップアップストア',
      curation: 'キュレーション',
      recommend: 'おすすめ商品',
      title1: '',
      title2: '個',
      title3: 'の',
      title4: '検索結果',
      recent_search: '最近検索語',
      recent_empty: '最近の検索履歴がありません。',
      popular_search: '人気検索語',
      empty_title: '検索結果がありません。',
      empty_body: 'キーワードをご確認ください。',
    },
    checkout: {
      temp_user_info:
        '入力した注文者情報で自動会員登録が行われ、注文後にログインして購入内訳の確認が可能です。',
      check_pass_title: 'パスワードの再入力リクエスト',
      input_user_info: '注文者情報入力',
      input_shipping_info: 'お届け先情報入力',
      duplicate_email: '重複メール',
      profile_change: 'アカウント設定です',
      header: '注文完了',
    },
    plus: {
      ready_for_contents: 'コンテンツを準備中です。',
      see_products_waiting_contents: 'コンテンツが準備されている間に、<br/>様々な商品を見てみませんか？',
      see_products: '商品を見に行く',
      content: 'コンテンツ',
      limited: '限定商品',
      best_product: 'ベスト商品',
    },
    plus_studio: {
      upload: 'アップロード',
      brand: {
        title: 'ブランド管理',
        description: '色、ロゴなどのブランドアイデンティティをサイトに適用してみてください。',
        button: '保存',
        information_title: '企業情報',
        plus_cover_title: 'プラスカバー',
        meta_tag_title: 'メタタグ',
        logo_title: 'プラスロゴ',
        name_title: 'プラスネーム',
        description_title: 'プラス紹介',
        official_title: '公式サイトURL',
        youtube_title: 'Youtube URL',
        instagram_title: 'Instagram URL',
        x_title: 'X URL',
        naver_blog_title: 'Naver Blog URL',
        tiktok_title: 'Tiktok URL',
        facebook_title: 'Facebook URL',
        afreeca_title: 'SOOP URL',
        chzzk_title: 'CHZZK URL',
        pc_cover_title: 'PC画像',
        pc_cover_description:
          'PCカバー画像は中央を基準として1440px * 640pxを超える場合、一部のデバイスで表示されない可能性があります。',
        mo_cover_title: 'Mobile画像',
        og_image_title: 'OpenGraph画像',
        og_image_description: '推奨サイズ(横1200px * 縦600px)',
        og_title_title: 'OpenGraphタイトル',
        og_description_title: 'OpenGraph内容',
        logo_description:
          '正方形比率の画像ファイルをアップロードしてください。\n（最小サイズ400px / 背景無しPNG可能 / 1MB以下）',
        logo_upload: 'アップロード',
        pc_cover_size: 'サイズ2560px * 640px',
        pc_cover_type: 'PNG, JPG, JPEG可能',
        pc_cover_volume: '最大3MB',
        pc_cover_upload: 'PCプラスショップのカバー画像を登録してください。',
        mo_cover_size: 'サイズ750px * 1276px',
        mo_cover_type: 'PNG, JPG, JPEG可能',
        mo_cover_volume: '最大3MB',
        mo_cover_upload: 'モバイルプラスショップのカバー画像を登録してください。',
        title_placeholder: 'プラスショップ {{name}} 名前を入力してください。',
        description_placeholder: 'ホームに紹介されるプラスショップ {{name}} 紹介内容を入力してください。',
        og_title_placeholder: 'OpenGraph {{name}} タイトルを入力してください。',
        og_description_placeholder: 'OpenGraph {{name}} 内容を入力してください。',
      },
      upload_placeholder: '添付されたファイルがありません。',
      live: {
        live_01: '掲示予約',
        live_02: '予約公開',
        live_03: '予約終了',
        live_04: 'プラスショップのホーム画面に表示される動画コンテンツを作り管理してみてください。',
        live_05: '動画バナー管理',
        live_06: '商品のURLを入力してください。',
        live_07: '公開回数の上限を超えました。バナーの公開ステータスが非公開に登録されます。',
        live_08: '公開回数の上限を超えました。最大5件まで公開できます。',
        live_09: '動画バナーを削除しますか？',
      },
      banner: {
        editor_title: 'プロモーションバナー登録',
        editor_title_2: 'プロモーションバナー修正',
        title: 'プロモーションバナー管理',
        description: 'プラスショップホーム画面のバナーに表示されるコンテンツを追加して管理してみてください。',
        tab_01: '全体コンテンツ管理',
      },
      ga_service: {
        menu: 'Integrating external services',
        title: 'Integrating external services',
        save_txt1: '',
        save_txt2: '',
      },
      popup: {
        enroll: {
          title: 'ポップアップ登録',
          plus_description: 'プラスショップホームに表示されるポップアップを新しく登録します。',
          all_description: 'MarppleShopホームに表示されるポップアップを新しく登録します。',
          cancel_button: 'キャンセル',
          submit_button: '登録',
          submit_success_modal_title: '登録完了',
          submit_success_home_modal_title: 'マプルショップホームの登録が完了しました',
          submit_success_studio_modal_title: 'スタジオ全体の登録が完了しました',
          submit_success_modal_message: 'ポップアップが登録されました。\n各設定画面で確認してください。',
          delete_modal_title: 'ポップアップの入力をキャンセルする',
          delete_modal_message: '入力中の内容は保存されません。\n前のページに戻りますか？',
        },
        modify: {
          title: 'ポップアップを編集する',
          plus_description: 'プラスショップホームに表示されるポップアップを編集します。',
          all_description: 'MarppleShopホームに表示されるポップアップを編集します。',
          cancel_button: '削除',
          submit_button: '編集',
          submit_success_modal_title: '編集完了',
          submit_success_modal_message: 'ポップアップが編集されました。\n各設定画面で確認してください。',
          delete_modal_title: '削除する',
          delete_modal_message:
            '削除後、ポップアップは復元できません。\nこのポップアップを削除してもよろしいですか？',
          delete_success_modal_title: '削除完了',
          delete_success_modal_message: 'そのポップアップの削除が完了しました。',
        },
        image_description: 'ポップアップ画像を登録してください。',
        popup_title: 'ポップアップタイトル',
        popup_title_placeholder: 'ポップアップタイトルを入力してください。',
        popup_title_description: 'このタイトルはポップアップ管理用で、外部には表示されません。',
        exposure_duration: '表示期間',
        exposure_duration_description: '非公開で登録したい場合は、現在の日付より前の日付に設定してください。',
        popup_image: 'ポップアップ画像',
        close_icon_color: '閉じるアイコンの色',
        button_bg_color: 'ボタン背景色',
        button_text_color: 'ボタンテキスト色',
        link_url: 'URLアドレス',
        link_url_placeholder: 'ポップアップ画像をクリックした際に移動するURLを入力してください。',
        link_url_description: 'URLを入力しない場合、クリックできません。',
        exposure_location: '表示画面',
        exposure_home: 'Marppleshop Home',
        exposure_studio: 'Studio Overall',
        preview_title: 'プレビュー',
        sort_success_title: '並べ替え完了',
        sort_success_message: 'ポップアップの並べ替えが完了しました。\n各設定画面でご確認ください。',
      },
      creator: {
        sort: {
          title: 'クリエイターの並び替え',
          desc: 'ホームとクリエイターページでおすすめ順に表示したいクリエイターの順番を変更してください。',
          sort_title: '並び替え順序',
          sort_desc: 'ドラッグ＆ドロップで順序を変更してください。',
          clipboard_title: 'クリップボード',
          clipboard_desc: '並び替え中のクリエイターを一時的に保存できます。',
          empty_box_desc:
            'クリエイターをドラッグして一時保存し、<br/>左の並び替えエリアに戻すと並び替えを変更できます。',
          success_title: 'クリエイターの並び替え完了',
          success_message:
            'クリエイターの並び替えが変更されました。<br/>PlusShopのホームで確認してください。',
          check_clipboard_title: 'クリップボードの確認',
          check_clipboard_desc:
            'クリップボードに並び替えられていないクリエイターがあります。<br/>すべての並び替えを完了して保存ボタンを押してください。',
          button: '保存',
        },
      },
      file: {
        image_size: '{{width}}px * {{height}}px',
        accepts: 'JPG, JPEG, PNG, GIF',
        accepts_without_gif: 'JPG, JPEG, PNG',
        max_file_volume: '最大{{max_file_volume}}MB',
      },
    },
    file: {
      volume_error_title: 'アップロード容量超過',
      volume_error_message:
        'アップロード可能な容量を超えました。<br/>{{volume}}以下のファイルでアップロードしてください。',
      extension_error_title: 'ファイルの添付ができません',
      extension_error_message:
        '選択したファイルは添付できません。\nファイルの拡張子をもう一度ご確認ください。',
      extension_forbidden_title: '',
      extension_forbidden_message: '',
      mime_type_not_allowed_title: '',
      mime_type_not_allowed_message: '',
      filename_invalid_title: '',
      filename_invalid_message: '',
      custom_validation_failed_message: 'ファイルの検証に失敗しました。',
      image_size_error_title: '画像サイズの確認',
      image_size_error_message: '画像サイズが間違っています。{{size}}のサイズでアップロードしてください。',
      image_size_over_error_message:
        '正しくない画像サイズです。<br/>{{size}}以下でアップロードしてください。',
      image_aspect_ratio_error_title: '画像のアスペクト比確認',
      image_aspect_ratio_error_message:
        '正しくないアスペクト比の画像です。<br/>{{aspect_ratio}} の比率でアップロードしてください。',
      volume_under_error_title: 'アップロード容量超過',
      volume_under_error_message:
        'アップロード可能な容量を満たしていません。<br/>{{volume}}以上のファイルでアップロードしてください。',
    },
    admin: {
      menu: {
        menu_01: 'メインバナー管理',
      },
      cast_on_air: {
        coa_01: 'Cast On-Air管理',
        coa_02: 'MarppleShopのホーム画面に表示される動画コンテンツを作り管理してみてください。',
        coa_03: '全体コンテンツ管理',
        coa_04: 'リンク先URL',
        coa_05: 'Cast On-Air コンテンツ作り',
        coa_06: 'Cast On-Air コンテンツ管理',
        coa_07: 'コンテンツタイトル',
        coa_08: 'コンテンツ説明',
        coa_09: 'iframe',
        coa_10: '商品追加',
        coa_11: '商品のURLを入力してください。',
        coa_12: 'Youtube, AfreecaTV, Chzzkなどの動画を表示できます。',
        coa_13: 'iframe URLのアドレスを入力してください。',
        coa_14: 'リンク先ボタンのURLを入力してください。',
        coa_15: 'バナー公開数上限超過',
      },
      banner: {
        banner_01: 'バナー画像を登録してください。',
        banner_02: '推奨サイズ : 896px X 1120px以上 / 3MB以下',
        banner_03: 'PCバナー設定',
        banner_04: '推奨サイズ : 750px X 562px以上 / 1MB以下',
        banner_05: 'モバイルバナー設定',
        banner_06: '共通設定',
        banner_07: 'モバイルバナー画像',
        banner_08: 'PCバナー画像',
        banner_09: 'バナーカテゴリー',
        banner_10: 'バナーを区分できるカテゴリーを英語で入力してください。',
        banner_11: 'バナーに挿入されるボタン内容を入力してください。',
        banner_12: 'ボタン内容',
      },
      site_manage: {
        integrating_external_services: {
          title1: '外部サービス連動',
          txt1: '外部サービスとの連動を管理するページです。',
          sub_title1: 'Googleアナリティクス設定',
          head1: 'Googleアナリティクス測定ID',
          txt2: 'Googleアナリティクスを設定すると、MarppleShopプラスの訪問者流入と離脱などのデータをリアルタイムで確認し分析することができます。',
          txt3: 'クリエイターガイド',
          txt4: "G-000000000'のような形式の測定IDを入力してください。",
          btn1: 'Save',
          txt3_2: 'に従ってGoogleアナリティクスを設定してみてください！',
          save_txt1: '保存完了！',
          save_txt2: '測定IDを保存しました。\n今からGoogleアナリティクスでデータを確認してみてください！',
          save_fail_txt1: '保存失敗',
          save_fail_txt2: 'カスタマーセンターにお問い合わせください。',
          btn2: '変更する',
          btn3: '連動解除',
          update_txt1: '変更完了！',
          update_txt2: '測定IDを変更しました。\n今からGoogleアナリティクスでデータを確認してみてください！',
          cancel_txt1: '連動解除完了！',
          cancel_txt2: 'Googleアナリティクスの連動を解除しました。',
          cancel_fail_txt1: '連動解除失敗',
          cancel_fail_txt2: 'カスタマーセンターにお問い合わせください。',
        },
      },
    },
    cheerup: {
      txt1: 'クリエイターのための応援の一言を残してください！',
      txt2: 'リンク、YouTubeなどをテキスト形式のショートカットとして挿入できます。',
      txt3: '最大6枚まで添付可能です。',
      btn_txt1: '応援する',
      title1: '応援する',
      sub_title1: 'クリエイターを応援する一言',
      btn_txt2: '修正',
      profile_txt1: '修正',
      profile_txt2: '10MB以内の画像ファイルをアップロードしてください。<br />（画像形式:JPG、JPEG、PNG）',
      profile_txt3: 'クリエイターを紹介できるフレーズを作成してください。',
      empty_title: '応援のメッセージを残してください！',
      empty_body:
        'クリエイターに応援の一言を残してください！<br />温かい応援のメッセージは大きな力になります！',
      my_page_empty_body:
        'お気に入りのクリエイターショップを訪れて、<br/>クリエイターを応援するメッセージを書いてみましょう。',
      my_page_empty_title: '応援メッセージはまだ書かれていません。',
      my_page_empty_button: 'クリエイター探し',
    },
    article: {
      sns_txt1: 'SNS',
      remove: 'ファンレターの削除',
      remove_desc: 'ファンレターを削除してもよろしいですか？',
      remove_ok: '削除',
      remove_cancel: 'キャンセル',
    },
    toast: {
      close: '閉じる',
      goto_cart: 'カートを見る',
      goto_product: '見に行く',
    },
    creator_shop: {
      sub_title1: 'あなたの好みにぴったりの',
      sub_title2: 'クリエイターを応援する一言',
      sub_title3: 'ファンたちの話が気になる時',
    },
    settings: {
      style_editor: {
        file_txt1: '最小高さ 20px、最大高さ80px | PNG | 最大 1MB',
        file_txt2: '',
        file_txt3: '',
        file_txt4: '1:1の正方形 | 最小 400px | JPG, JPEG, PNG | 最大 1MB',
        banner_help_txt1:
          'バナー画像は中央基準で1440pxを超えると、一部のデバイスで切れて表示される場合があります。',
      },
      product_editor: {
        sample_order: 'サンプル注文',
      },
    },
    gnb: {
      creator_ranking: 'ランキング',
      creator_ranking_weekly: '週間人気クリエイター',
      creator_ranking_monthly: '月間人気クリエイター',
      plus: 'MarppleShop Plus',
      plus_all: '全体を見る',
      creator_view: 'クリエイタービュー',
      creator_all: 'クリエーター全体',
      creator_new: 'MarppleShopのニューフェイス',
      monthly_top_one: '{{month}}月のクリエイターTOP１',
      more: 'もっと見る',
      menu: {
        home: 'ホーム',
        creator: 'Creator',
        popup: 'ポップアップ',
        shopping: 'Shop',
        mypage: 'マイページ',
        real_ranking: 'リアルタイム/ランキング',
        real_ranking_bottom: 'ランキング',
        recommend: '推薦',
        explore: '探索',
        goods: 'グッズ',
        handmade: 'ハンドメイド',
        brand_deal: 'Brand Deal',
        ebook: 'E-BOOK',
      },
    },
    creator_filter: {
      all: 'ALL',
    },
    price: {
      price_all: '総商品金額',
    },
    customer_order: {
      inquire: 'お問い合わせ',
    },
    error: {
      404: {
        title: 'ご希望のページが見つかりません。',
        description:
          'お探しのページのアドレスが間違って入力されているか、<br/>アドレスの変更または削除により接続できません。<br/>入力したページのアドレスが正確であるかもう一度確認してください',
      },
      500: {
        title: 'しばらくしてからもう一度ご確認ください。',
        description:
          'サービスのご利用にご不便をおかけして申し訳ございません。<br/>一時的にサーバーで問題が発生しました。<br/>しばらくしてからもう一度お試しください。',
      },
      suspend_store: {
        title: '現在運営されていないショップです。',
        description: 'MarppleShopで新しいクリエイターを見つけよう。',
      },
    },
    adult: {
      need_verify: '年齢確認',
      go_verify: '認証する',
      go_main: 'メインに戻る',
      verify_cancel: '認証キャンセル',
      verify_cancel_description: '認証がキャンセルされました。<br/>再度お試しください。',
    },
    creator_studio: {
      confirm_title1: '本当に解除しますか？',
      confirm_body_txt1:
        'YouTubeとMarppleShopの接続を解除せずに、<br/>公開された商品を非表示にすることができます！',
      confirm_btn_ok: '解除する',
      confirm_btn_cancel: '戻る',
      store_delivery_company_title: '配送ポリシー',
      store_delivery_company_desc:
        '商品ごとに配送料、出荷地などが異なる場合、配送ポリシーを異なるように設定できます。',
      external_services: {
        tab1: 'Googleアナリティクス設定',
        tab2: 'APIキー発行',
      },
      terms: {
        welcome: '마플샵 스튜디오에 오신 걸 환영합니다!',
        guide: '샵을 꾸미고 상품을 만들어보세요.<br/>판매 승인 심사는 평일 영업일 기준 2~5일 소요됩니다.',
        start_service: '동의하고 스튜디오 시작하기',
        all_check: '전체 동의',
        service_check: '마플샵 스튜디오 이용약관 동의',
        privacy_check: '개인정보처리방침 동의',
        age_check: '만 14세 이상입니다.',
        not_yet: '진행 불가',
        not_yet_message:
          '크리에이터 스튜디오 이용약관 및 개인정보처리방침 및<br/>만 14세 이상에 모두 동의해 주세요.',
      },
      printable_product_alert:
        '制作用のデザイン案が生成されており、修正はできません。<br>デザインを変更する場合は、商品複製機能をご利用ください。',
    },
    shipping_guide: {
      departure_date_info: '配送出発日のご案内',
      departure_date_info_marpple_desc1:
        'MarppleShop配送商品とMarppleShop オーダーメイド配送商品を一緒に注文すると、配送料は一度だけ請求されます',
      departure_date_info_marpple_desc2:
        '一緒に注文した商品の配送出発日が異なる場合、最も遅い日付に合わせて発送されます。',
      departure_date_info_marpple_desc3:
        '予約販売(プリオーダー)商品は配送が遅れる可能性があるため、他の商品とは別に注文することをお勧めします。',
    },
    product_detail: {
      ebook_illustrator: 'イラスト',
      ebook_translator: '翻訳',
      ebook_publisher: '出版社',
      ebook_publication_date: '出版日',
      재고부족: '在庫不足',
      quantity_exceeded: '購入可能な数量を超過しました。',
      remaining_stock_quantity:
        '選択したオプションの残り<span style="font-weight: 700; color: #1C75FF;">在庫は{{remaining_stock_quantity}}個</span>です。<br/>オプションを確認してください。',
      option_not_selected: '商品オプション未選択',
      option_not_selected_desc: 'オプションが選択されていません。<br />商品オプションを選択してください。',
      out_of_stock: {
        title1: '商品在庫案内',
        title2: '商品再入荷予定',
        title3: '商品登録案内',
        description1: 'この商品は一時的に品切れ状態です。<br/>再入荷後、公開および販売が開始されます。',
        description2: '以下のオプションは一時的に品切れ中で、<br/>再入荷後に販売が開始されます。',
        description3:
          '本商品の{{ len }}のオプションは即時販売が可能で、<br/>以下のオプションは再入荷後に販売が開始されます。',
        submit: {
          ok: '商品登録',
          cancel: 'オプションの再選択',
        },
      },
      required_bank: {
        title: '口座登録案内',
        description:
          '商品を作る前に、口座情報の登録が必要です。<br/>商品が売れると、<br/>登録した口座に収益が精算されます。',
        ok: '口座登録',
        cancel: '次に',
      },
      duplicated_option: '重複したオプション',
      duplicated_option_desc: 'すでに選択されているオプションです。<br />数量を調整してください。',
      no_select_option: 'オプションが未選択です',
      no_select_option_desc: '選択された商品オプションがありません。<br />商品オプションを選択してください！',
      over_quantity: '数量が制限を超えています',
      over_quantity_desc: '最大数量を選択しました。<br />追加するには削除してください。',
      duplicated_option_desc2: 'すでに選択されているオプションです。<br />選択内容を確認してください。',
      select_phonecase: '機種を選択してください。',
    },
    funding: {
      modal: {
        title: '参加ファン',
        tabs: {
          ranking: 'ランキング順',
          created_at: '最新順',
        },
        item: {
          label: '{{nickname}}さんがファンディングしました。',
        },
      },
      section: {
        ranking_title: '参加ランキング',
      },
      cta: {
        sold_out: 'ファンディングが終了しました！',
        support: 'ファンディング参加',
      },
      card: {
        coming_soon: '{{date}} リリース予定',
        status: {
          success: 'プロジェクト成功',
          failed: 'プロジェクト終了',
          ing_day: '残り{{day}}日',
          ing_hour: '残り{{hours}}時間',
          ing_minute: '残り{{minutes}}分',
          ing_second: '残り{{seconds}}秒',
        },
        share: 'シェア',
        toast: {
          success: 'アドレスがコピーされました。',
        },
      },
      form: {
        percentage: {
          label: '達成率',
          status: {
            ing: 'あと{{goal}}円',
            breakthrough: '{{goal}}円突破',
            success: 'プロジェクト成功',
          },
        },
        supporters: {
          label: '参加者数',
          count: '<strong class="{{font}}">{{count}}</strong><i>名</i>',
        },
        end: {
          label: '終了まで',
          remain_day: '<strong class="{{font}}">{{remain}}</strong><i>日残り</i>',
          remain_time: '<strong class="{{font}}">{{remain}}</strong><i>残り</i>',
        },
      },
      guide: {
        goal: '目標金額',
        participation: '参加期間',
      },
      creator: {
        menu: {
          name: 'ファンディング',
        },
        list: {
          title: '合計{{count}}個のファンディング',
        },
      },
    },
    question: {
      문의하기: 'クリエイターお問い合わせ',
      nickname: 'ニックネーム',
      kind: '問い合わせ種別',
      qna: '商品についてのお問い合わせ',
      qna_membership: 'メンバーシップについてのお問い合わせ',
      qna_support: 'スポンサーシップについてのお問い合わせ',
      plan_name: 'プラン名',
      ' 문의와 관련된 파일을 첨부해 주세요.': 'ファイルを添付してください。',
      '개인정보수집 ・ 이용 동의': '用規約に同意。',
      '사용자 정보': 'ユーザー情報',
      '필수 입력사항': '必須項目',
      이름: 'お名前',
      '이름을 입력해 주세요.': 'お名前を入力してください。',
      error: 'エラー',
      연락처: '電話番号',
      '없이 연락처를 입력해 주세요.': 'ハイフンなしで、01000000000。',
      이메일: 'メール',
      '문의 내용': '内容',
      '문의 내용을 입력해 주세요.': '問い合わせ内容を入力してください。',
      '문의 내용은 최대 2000bytes까지 입력 가능합니다.<br>(한글 1000자, 영문 2000자)':
        'お問い合わせ内容は最大1000文字まで入力可能です。<br>(ハングル1000文字、英語2000文字)',
      '파일 첨부': '添付',
      'jpg, png, zip, pdf 확장자만 첨부 가능하며, 10MB까지 가능합니다.<br />(여러 사진을 첨부해야 한다면 zip 파일로 첨부해 주세요.)':
        'jpg、png、zip、pdfのみ添付可能、10MBまで可能です。<br />(複数の写真はzipで添付してください。)',
      보기: '見る',
      취소: 'キャンセル',
      '문의 접수': '問い合わせ',
      '답변 받으실 이메일 주소를 입력해 주세요.': 'メールを入力してください。',
      제목: 'タイトル',
      '제목을 입력해 주세요.': 'タイトルを入力してください。',
      '문의 내용을 자세하게 작성해 주세요.':
        'お問い合わせ内容を詳しくご記入ください\n同じ内容の繰り返しのお問い合わせや、暴言の使用はご遠慮ください。',
      file_modal_title: 'ファイルの添付ができません',
      file_modal_content: '選択したファイルは添付できません。\nファイルの拡張子をもう一度ご確認ください。',
      file_modal_content_desc: '（添付可能なファイル形式：jpg、png、zip、pdf）',
      '문의 정보': '問い合わせ情報',
      upload: 'アップロード',
      submit: '問い合わせ受付',
      '필수 입력 사항입니다.': '必須項目です。',
      '정확한 연락처를 입력해주세요.': '正確な連絡先を入力してください。',
      '정확한 이메일을 입력해 주세요.': '正確なメールアドレスを入力してください。',
      '100자 이하로 입력해주세요.': '100文字以内で入力してください。',
      '250자 이하로 입력해주세요.': '250文字以内で入力してください。',
      '300자 이하로 입력해주세요.': '300文字以内で入力してください。',
      '2000bytes 이하로 입력해주세요.': '2000バイト以内で入力してください。',
      '특수문자를 제외하고 입력해주세요.': '特殊文字を除いて入力してください。',
      '숫자만 입력해 주세요.': '数字のみを入力してください。',
      '개인 정보 수집 및 이용 동의후 접수해주세요.':
        '個人情報の収集および利用に同意した後に送信してください。',
      commission: {
        title: 'コミッション申請情報',
        name: 'コミッション名',
        number: '申請番号',
        check: '申請書確認',
        button: 'コミッション詳細を見る',
        button_studio: 'コミッション申請書を見る',
      },
      qna_commission: 'コミッション問い合わせ',
      add_answer: 'お問い合わせ内容を確認した後、お客様が理解しやすいように回答してください。',
    },
    studio: {
      editor: {
        max_length_10_txt: '商品詳細画像は最大10枚までアップロードできます。',
        instagram_error_title: 'Instagramのリンク不可',
        instagram_error_description: '現在のURLは対応していません。\n公開状態の投稿のURLを入力してください。',
      },
      welcome_title: 'MarppleShopスタジオへ<br/>ようこそ！',
      welcome_guide: 'PCやスマートフォンでいつでも<br/>グッズを作成できます。',
      page: {
        products: 'MarppleShop制作配送',
        products_guide: 'デザインがあれば、たった3分でMarppleShopの商品を作成できます。',
        products_order: '注文履歴',
        products_order_guide: '一週間の注文履歴を確認できます。',
        products_creator: 'クリエイター配送商品',
        products_creator_guide: '在庫のある商品やハンドメイドの商品を販売してみましょう。',
        products_creator_inventory: '在庫管理',
        products_creator_inventory_guide: '登録されている商品を確認し、管理してください。',
        products_creator_order: '注文管理',
        products_creator_order_guide: '新規注文情報を確認し、管理してください。',
        products_creator_shipment: '配送/発送管理',
        products_creator_shipment_guide: '商品の発送処理や配送情報を管理してください。',
        products_creator_refund: '返金管理',
        products_creator_refund_guide: '返金事項を確認し、管理してください。',
        products_digital: 'デジタル/電子書籍',
        products_digital_guide: '多様なデジタル/電子書籍を簡単かつ迅速に販売できます。',
        products_digital_order: '注文履歴',
        products_digital_order_guide: 'デジタル/電子書籍の注文履歴を確認できます。',
        question: '顧客問い合わせ',
        question_guide: '顧客の問い合わせ内容を確認し、対応してください。',
        store_style: 'ショップデザイン',
        store_style_guide: 'プロフィール、ロゴ、バナーなどを変更してショップをデザインしましょう。',
        store_product_arrangement: '商品並べ替え',
        store_product_arrangement_guide: 'ショップの商品をドラッグして、好きな順に並べ替えましょう。',
        store_info: 'ショップ情報',
        store_info_guide: 'ショップの基本情報を管理するページです。',
        store_ecommerce_info: 'クリエイター情報',
        store_ecommerce_info_guide: 'クリエイター商品販売のための情報を入力するページです。',
        youtube_connection: 'YouTubeチャンネルでMarppleShopの商品を販売してみましょう！',
        youtube_connection_guide:
          'MarppleShopは韓国初のYouTube商品販売プラットフォーム公式パートナーで、信頼できます。',
        open_api: 'API連携',
        open_api_guide: '外部サービスとの連携を管理するページです。',
        adjustments: '精算管理',
        adjustments_guide:
          '精算管理では、各商品およびサービスの精算基準に基づいて月別精算内容を確認できます。',
        withdraws: '出金申請',
        withdraws_guide: '一ヶ月間の販売利益を出金申請できます。',
        bank_account: '口座情報登録',
        bank_account_guide: '登録した口座情報で利益を精算できます。',
        products_analytics: '商品別販売分析',
        products_analytics_guide: '作成した商品の販売ランキングを確認してください。',
        faq: 'FAQ',
        faq_guide: 'クリエイターがよく質問する内容を確認してください。',
        solution: '通報受付',
        solution_guide: 'ショップまたは商品などに受け付けられた通報を確認できます。',
      },
      tooltip: {
        adjustments:
          '<h4>MarppleShop商品精算</h4><div>出荷日を基準に月ごとに算出されます。</div><br/><h4>商品精算{{tpl_adjustments}} & デジタル商品精算</h4><div>購入確定日を基準に月ごとに算出されます。</div>',
        withdraw_amount:
          '<div>MarppleShop商品精算金額 + 商品精算金額 = 出金予定金額</div><br/><h4>MarppleShop商品精算金額とは？</h4><br/><div>- 個人クリエイター <div>MarppleShop商品精算金額 - 消費税（10%） - 源泉徴収税（3.3%）<br />= グッズ精算金額</div><br/>- 事業者クリエイター <div>MarppleShop商品精算金額 = MarppleShop商品精算金額 <br/>※ 事業者の場合、税金計算書発行後に出金が可能です。</div></div>',
        pg_commission_title: 'PG手数料',
        pg_commission_desc: 'PG社手数料3.2%に10%の付加価値税を加えた価格です。',
      },
    },
    share: {
      marppleshop_description: '想像するすべてを現実にできる<br/>クリエイターコマース、MarppleShop',
      store_main_description: 'MarppleShopで[{{creator_name}}]だけのグッズをチェックしよう。',
      plus_main_description: '[{{plus_name}}]で公式グッズを手に入れるチャンス！',
      creator_view_description: 'MarppleShopで[{{creator_name}}]の物語を聞いてみよう。',
      marppleshop_app_download: 'アプリをダウンロード',
    },
    order: {
      country: '国',
    },
    seller_studio: {
      shop_management: {
        shop_info: {
          save: '保存',
          ciety: {
            label: 'CIETY連動',
            button: 'CIETYを作成',
            prefix: 'ciety.xyz/@',
            placeholder: 'サイエティコミュニティドメインを入力してください。',
            connecting: '連動リクエスト中',
            disconnect: '連動解除',
            disconnect_confirm_message_title:
              'MarppleShopクリエイターショップとコミュニティの連動が解除されます。\n以下の内容を必ずご確認ください。',
            disconnect_confirm_message_1:
              '連動を解除すると、メンバーシッププランのコミュニティ特典とコミュニティのメンバーシップ\nグループがすべて削除されます。',
            disconnect_confirm_message_2:
              'メンバーシップ会員にコミュニティ特典削除の案内メールが自動送信されます。',
            disconnect_confirm_message_3: 'この作業は元に戻すことができませんので、慎重に進めてください。',
            is_mobile: 'PCで進めてください。',
          },
          category: {
            label: 'カテゴリー',
            select: '選択',
          },
          style: {
            label: 'スタイル',
            add: '追加',
            edit: '修正',
            title: 'クリエイタースタイル',
            cancel_button: 'キャンセル',
            save_button: '保存',
          },
          phone: {
            label: 'カスタマーサービス番号',
          },
        },
      },
      question_list: {
        tab: {
          all: '全体',
          product: '商品に関する問い合わせ',
          membership: 'メンバーシップに関する問い合わせ',
          support: 'サポートに関する問い合わせ',
          commission: 'コミッション問い合わせ',
        },
        filter: {
          create_at: '登録日付',
          search_key: '検索条件',
          status: '進行状態',
          reset: 'リセット',
          search: '検索',
        },
        table: {
          status: '進行状態',
          create_at: '登録日時',
          user_name: '名前',
          nickname: 'ニックネーム',
          title: 'タイトル',
          product_name: '商品名',
          order_id: '注文番号',
          product_id: '商品番号',
          phone_number: '電話番号',
          email: 'メールアドレス',
          plan_name: 'プラン名',
          product_or_plan_name: '商品名／プラン名',
        },
        status: {
          question: '問い合わせ受付',
          answer: '回答完了',
          add_question: '追加問い合わせ受付',
          add_answer: '追加回答完了',
        },
      },
      navigation: {
        welcome: 'MarppleShopを始める',
        mps_product: 'MarppleShop制作配送商品',
        make_product: '商品登録',
        orders: '注文履歴',
        creator_product: 'クリエイター配送商品',
        shipping: '配送管理',
        digital_product: 'デジタル/電子書籍',
        customer_management: '顧客管理',
        youtube_connect: 'YouTubeショッピング',
        open_api: 'API連携',
        adjustments: '精算',
        product_adjustments: '商品精算',
        product_sales_analytics: '商品別販売分析',
        creator_support: 'サポートセンター',
        orders_management: '注文管理',
        membership_commission_support: 'メンバーシップ/コミッション/後援',
        membership: 'メンバーシップを作成',
        commission: 'コミッションを作成',
        support: '後援を作成',
        membership_commission_support_management: 'メンバーシップ/コミッション/後援管理',
        membership_guide: 'サービス紹介',
        membership_adjustments_share: '収益率設定',
        product_inquiry: '商品問い合わせ',
        product_management: '商品管理',
        sales_management: '販売管理',
        integrated_order_search: '',
      },
      editor: {
        pbg: {
          new: {
            title: '',
          },
          modify: {
            title: '',
          },
        },
        tpl: {
          modify: {
            title: '',
          },
        },
        oversea: {
          modify: {
            title: '',
          },
        },
      },
      onBoarding: {
        title: 'ようこそ！',
        title_finish:
          'スタジオオンボーディングを完了すると、MarppleShopで使用できる3,000ポイントを差し上げます。',
        desc: 'スタジオのオンボーディング完了で、MarppleShopで使える3,000ポイントをプレゼント！',
        desc_finish:
          'MarppleShopで使用できる3,000ポイントが付与されました！<br/>デビューおめでとうございます！',
        count_desc: '残り',
        complete: '完了',
        start: {
          cate_title: 'MarppleShopを始める',
          shop_info_setting: {
            item_title: 'ショップ情報設定',
            item_desc: 'お客様に表示されるショップ名、紹介、ドメインなどの基本情報を設定してください。',
            item_full_desc:
              'お客様に表示されるショップ名、紹介、ドメインなどの基本情報を設定してください。<br/>正確な情報は信頼を与え、ショップ訪問者が10%以上増加する可能性があります。',
            button_text: '設定する',
          },
          shop_deco_setting: {
            item_title: 'ショップをカスタマイズ',
            item_desc: '自分だけのショップを装飾して、自分の個性を自由に表現してください。',
            item_full_desc:
              '自分だけのショップを装飾して、自分の個性を自由に表現してください。<br/>ショップをカスタマイズすると、顧客の滞在時間が平均25%増加する可能性があります。',
            button_text: 'カスタマイズ',
          },
          creator_info_setting: {
            item_title: 'クリエイター情報を入力',
            item_desc: 'クリエイター配送商品の販売に必要な情報を入力してください。',
            item_full_desc:
              'クリエイター配送商品の販売に必要な情報を入力してください。<br/>情報が明確なショップは「いいね」の数が10%増加する可能性があります。',
            button_text: '情報を入力する',
          },
          bank_info_setting: {
            item_title: '口座情報を登録',
            item_desc: '精算を受け取るための口座情報を登録してください。',
            item_full_desc:
              '精算を受け取るための口座情報を登録してください。<br/>収益金を安全に引き出せるので、運営の安定性を向上させることができます。',
            button_text: '登録する',
          },
          title: 'スタジオを始める',
          desc: '自分だけのショップを作りましょう！',
        },
        sales: {
          cate_title: '販売を始める',
          mps_product_sales: {
            item_title: 'MarppleShop商品を登録',
            button_text: '登録へ進む',
            item_desc: 'デザインさえあればマープルショップ商品を登録できます。',
            item_full_desc:
              'デザインさえあればマープルショップ商品を登録できます。<br/>商品制作から配送、CS、在庫管理まで、すべてマープルショップが対応します。',
          },
          creator_product_sales: {
            item_title: 'クリエイター配送商品を登録',
            item_desc: '自分で作った商品や在庫を持っている商品を販売してみましょう。',
            item_full_desc:
              '自分で作った商品や在庫を持っている商品を販売してみましょう。<br/>独自の商品を登録して、ファンとコミュニケーションを取りながら収益を得ましょう。',
            button_text: '登録へ進む',
          },
          digital_product_sales: {
            item_title: 'デジタル/電子書籍を登録する',
            item_desc: '壁紙、GoodNotes、電子書籍などのデジタル商品の販売を試してみましょう。',
            item_full_desc:
              '壁紙、GoodNotes、電子書籍などのデジタル商品の販売を試してみましょう。<br/>デジタル形式で収益を得ましょう。',
            button_text: '登録へ進む',
          },
        },
        debut: {
          cate_title: 'MarppleShopデビュー',
          sns_setting: {
            item_title: 'SNS設定をする',
            item_desc: 'ファンと簡単かつ迅速にコミュニケーションを取れるSNSを教えてください。',
            item_full_desc:
              'ファンと簡単かつ迅速にコミュニケーションを取れるSNSを教えてください。<br/>SNSを通じてファン層を増やし、トラフィックの流入を増やすことができます。',
            button_text: '登録へ進む',
          },
          chat_cheer: {
            item_title: '応援することでコミュニケーションを取る',
            item_desc: '応援する掲示板を通じてファンと暖かいコミュニケーションを取りましょう。',
            item_full_desc:
              '応援する掲示板を通じてファンと暖かいコミュニケーションを取りましょう。<br/>ファンとのコミュニケーションが強化され、ブランドの忠誠心が向上します。',
            button_text: '登録へ進む',
          },
          creator_guide: {
            item_title: 'クリエイターガイドを確認する',
            item_desc: '成功するショップ運営のために必須のガイドを確認しましょう。',
            item_full_desc:
              '成功するショップ運営のために必須のガイドを確認しましょう。<br/>成功的な運営方法を習得し、より良い収益モデルを構築できます。',
            button_text: '登録へ進む',
          },
        },
        quick: {
          menu_title: '商品を販売する',
          menu_mps_product: 'MarppleShop制作配送商品を作成する',
          menu_creator_product: 'クリエイター配送商品を登録する',
          menu_digital_product: 'デジタル/電子書籍商品を登録する',
          online_popup_link: 'オンライン <br /> ポップアップストア',
          offline_popup_link: 'オフライン <br /> ポップアップストア',
          youtube_link: 'YouTubeショッピング',
          youtube_link_desc: 'YouTubeチャンネルでマープルショップの商品を <br />販売してみましょう！',
          guide_link: 'クリエイターガイド',
          guide_link_desc: 'MarppleShopスタジオを便利で簡単に <br />利用してみましょう！',
          commerce_creator_title: 'コマースクリエイター2期募集',
          commerce_creator_desc: 'あなたのチャンネルにぴったりの<br/>ブランドをマッチングします。',
          purchase_analyze_title: '新機能、商品別累積販売量',
          purchase_analyze_desc: '各商品がどれだけ売れたでしょうか？<br/>販売戦略の参考にしてみてください。',
          sales_trend_title: '新機能、期間別販売推移',
          sales_trend_desc: 'ショップの売上は成長傾向ですか？<br/>特定期間の販売成果を確認してください。',
          goods_partner_title: 'グッズパートナーズ申請',
          goods_partner_desc: 'Vtuberなら申請してください！<br/>グッズ制作A-Zを責任持ちます',
          category_renewal_title: '商品カテゴリー変更のお知らせ',
          category_renewal_desc: '商品カテゴリーを新分類システムに更新いたします（2025年7月28日予定）',
        },
        continue: '続ける',
        completed: {
          title: '完了！',
          desc: 'ショップを始めましょう。',
        },
        caution: 'ポイント付与には最大1分かかる場合があります。',
      },
      popup: {
        sort_option: {
          all: '全体',
          public: '公開',
          private: '非公開',
          reservation: '公開予定',
        },
        tab: {
          all: '全ポップアップ',
          sort: '並べ替え変更',
        },
        list: {
          title: 'ポップアップ管理',
          description: 'クリエイターショップメインに表示するポップアップを管理します。',
          submit_button: '登録',
          save_button: '保存',
          add_card_description: 'クリエイターショップメインに表示するポップアップを追加して管理しましょう。',
          mo_add_card_description:
            'クリエイターショップメインに表示するポップアップを追加し、管理してください。',
        },
        enroll: {
          title: 'ポップアップ登録',
          description: 'クリエイターショップメインに表示する新しいポップアップを登録します。',
          cancel_button: 'キャンセル',
          submit_button: '登録',
        },
        modify: {
          title: '編集',
          description: 'クリエイターショップメインに表示されるポップアップを編集します。',
          cancel_button: '削除',
          submit_button: '編集',
        },
        image_description: 'ポップアップ画像を登録してください。',
        popup_title: 'ポップアップタイトル',
        popup_title_placeholder: 'ポップアップのタイトルを入力してください。',
        popup_title_description: 'このタイトルは管理用で、外部には表示されません。',
        exposure_duration: '表示期間',
        exposure_duration_description:
          '非公開登録を希望する場合は、現在の日付より前の日付を設定してください。',
        popup_image: 'ポップアップ画像',
        close_icon_color: '閉じるアイコンの色',
        button_bg_color: 'ボタン背景色',
        button_text_color: 'ボタンテキスト色',
        link_url: 'URLアドレス',
        link_url_placeholder: 'ポップアップ画像をクリックした際に移動するURLを入力してください。',
        link_url_description: 'URLを入力しない場合、クリックできません。',
        exposure_location: '表示画面',
        exposure_home: 'ホーム画面',
        exposure_product_detail: '商品詳細画面',
        exposure_home_and_product_detail: 'ホーム + 商品詳細画面',
        exposure_all: '商品カテゴリー',
        exposure_mps: 'MarppleShop制作配送商品',
        exposure_tpl: '在庫商品',
        exposure_pbg: 'クリエイター配送商品',
        exposure_dtg: 'デジタル/電子書籍',
        exposure_custom: '直接入力',
        preview_title: 'プレビュー',
        home_and_product_detail_description:
          'ポップアップはクリエイターショップのホームとすべての商品詳細ページに表示されます。',
        home_description: 'ポップアップはクリエイターショップのホームに表示されます。',
        product_input_placeholder: 'ポップアップを表示する商品のURLを入力してください。',
        product_input_description: '入力したURLの商品詳細ページにポップアップが表示されます。',
        sort_success_title: '並べ替え完了',
        sort_success_message: 'ポップアップの並べ替えが完了しました。\n各設定画面でご確認ください。',
      },
      adjustment: {
        marppleshop_product: 'MarppleShop制作配送商品',
        creator_product: 'クリエイター配送商品',
        tpl_product: '在庫商品',
        digital_product: 'デジタル/電子書籍',
        amount: '{{product}} 精算金額',
      },
      product_guide: {
        title: 'MarppleShop制作配送商品とクリエイター配送商品とは？',
        about_pod: 'MarppleShop制作配送商品',
        pod_guide_001: '自分で商品を作らなくても、自分がデザインしたグッズを販売できます。',
        pod_guide_002:
          '商品の製造、配送、顧客対応、在庫管理まで、すべてマプルショップが対応する商品を指します。',
        about_pb: 'クリエイター配送商品',
        pb_guide_001: '自分で作り、配送する商品を、複雑な承認手続きなしで3分で登録できます。',
        pb_guide_002: '自分のショップやリンクを通じて、すぐに販売を開始できる商品を指します。',
      },
      inspect_stores_products: {
        header: {
          title: '商品検収',
          description: '新規に登録されたクリエイター配送商品を検収するページです。',
          list_title: '検収管理',
          list_description: 'クリエイター全体商品の検収状態を確認して管理できるページです。',
        },
        filter: {
          create_at: '登録日付',
          search_key: '検索条件',
          status: '進行状態',
          reset: '初期化',
          search: '検索',
        },
        table: {
          product_name: '商品名',
          creator_name: 'クリエイター名',
          store_name: 'ショップ名',
          product_id: '商品登録番号',
          product_type: '商品タイプ',
          category: '大分類/中分類',
          delivery_type: '配送形態',
          delivery_way: '配送方法',
          product_price: '販売価格',
          delivery_price: '配送料 \n (基本/離島山間)',
          kc_certificate: 'KC認証書及びその他認証',
        },
        status: {
          approved: '検収完了',
          rejected: '販売保留',
          not_started: '検収未完了',
        },
      },
      membership_setting: {
        title: 'メンバーシップ設定',
        tooltip_content:
          'メンバーシップ商品特典として設定します。\n選択したメンバーシップに加入した会員のみ購入できる商品特典として適用されます。\n* メンバーシッププランが公開状態の時、メンバーシップ商品の販売が開始されます。',
        private: '非公開',
      },
      integrated_order_search: {
        description: '',
      },
    },
    ad_res: {
      terms_modal: {
        title: '個人情報収集・利用に同意',
        content_title_1: '収集・利用機関名',
        content_title_2: '収集項目',
        content_title_3: '収集・利用目的',
        content_title_4: '保有および利用期間',
        content_description_1: 'Marpple Corporation',
        content_description_2: '(必須) 氏名、連絡先、メールアドレス',
        content_description_3: 'MarppleShopクリエイター応募およびサービス提供',
        content_description_4: 'クリエイター申請日から1年間',
        tip: '個人情報提供者は、個人情報の収集および利用に関する同意を拒否する権利がありますが、その場合、クリエイターの応募および案内ができません。',
        submit: '確認',
      },
      title: 'MarppleShopクリエイター応募',
      description_1: 'MarppleShopで、あなたの想像を現実にしましょう。',
      description_2:
        '個人または企業のどなたでも応募可能で、本人がデザインや制作した、または著作権を所有している商品やコンテンツがあれば参加できます。',
      mo_description_2:
        '個人または企業のどなたでも応募可能で、<br />本人がデザインや制作した、<br />または著作権を所有している商品やコンテンツがあれば参加できます。',
      required: '必須',
      required_one: '1つ以上必須入力',
      required_one_optional: '1つ以上入力',
      basic_info: '基本情報',
      brand_name: 'ショップ名',
      brand_placeholder: 'ショップ名を入力してください。',
      brand_validation: '2文字以上20文字以内で入力してください。',
      domain_name: 'ドメイン名',
      domain_placeholder: 'your_domain',
      domain_validation: '英文字、数字、アンダーバー(_)で2～20文字以内で入力してください。',
      domain_validation_error: '英文字、数字、アンダーバー(_)のみ、2～20文字以内で使用可能です。',
      domain_duplicate: 'このドメインはすでに使用されています。別のドメインを入力してください。',
      creator_cate: 'クリエイターカテゴリー',
      apply: '申請',
      introduce: '自己紹介',
      introduce_placeholder: '自分自身またはショップを紹介してください。',
      introduce_error: '200文字以内で入力してください。',
      contact_info: '連絡先情報',
      email_name: 'メールアドレス',
      email_placeholder: 'メールアドレスを入力してください。',
      email_error: '正しいメールアドレス形式で入力してください。',
      phone: '電話番号',
      phone_placeholder: 'ハイフン(-)を除いた数字のみを入力してください。',
      phone_error: 'ハイフン(-)を除いた正しい電話番号形式で入力してください。',
      portfolio: 'SNS / ポートフォリオ',
      portfolio_sub: 'ご自身をよく紹介できるSNSまたはポートフォリオを1つ以上入力してください。',
      sns: '主要SNS',
      sns_placeholder: '運営中のSNSチャンネルのURLを入力してください。',
      url_error: '正しいメール形式で作成してください。',
      portfolio_file: 'ポートフォリオファイル',
      portfolio_file_validation:
        'JPG、PNG、PPT、KEYNOTE、PDF形式のファイルを50MBまでアップロードできます。（最大3つまでアップロード可能）',
      file_upload: 'ファイルアップロード',
      delete: '削除',
      website: 'ポートフォリオサイト',
      website_placeholder:
        '個人ウェブサイト、ノートフォリオ、ビハンスなどの参照サイトのURLを入力してください。',
      mo_website_placeholder: '個人ウェブサイト、ノートフォリオ、ビハンスなどの参照サイトのURL。',
      agreement: '個人情報収集・利用に同意',
      agree_all: 'すべて同意',
      necessary: '[必須]',
      agree_privacy: '個人情報の収集および利用に関する内容を確認し、同意します。',
      mo_agree_privacy: '個人情報の収集および利用に<br/>関する内容を確認し,同意します。',
      view: '見る',
      agree_terms: '14歳以上です。',
      notification: '必ずお読みください！',
      notification_1:
        '販売するコンテンツの著作権は販売者であるクリエイターに帰属し、申請の際に著作権者であることを確認したものとみなされます。',
      notification_2:
        '他者の権利を侵害したり、名誉を毀損するような画像やデザインを投稿する責任はクリエイターにあります。',
      notification_3:
        '個人情報は同意した目的のみに使用されます。閲覧、修正、削除の要求は、個人情報管理者(partner@marppleshop.com)またはカスタマーセンター(1566-5496)までご連絡ください。',
      letter_count: '',
      email_duplicate: '重複したメールです。',
      finish_title: 'ショップ作成リンクを送りましたので、メールをご確認ください！',
      finish_title_mo: 'ショップ作成リンクを送りましたので、<br/>メールをご確認ください！',
      finish_description_1:
        'あなた専用のショップを作成できます。今すぐショップを開設して商品を作りましょう！',
      finish_description_2:
        'メールが届かない場合は、迷惑メールフォルダを確認するか、<br /><a href="mailto:cs@marppleshop.com">cs@marppleshop.com</a>までお問い合わせください。',
      finish_info_desc:
        '参考資料が不足している場合や、不適切な内容が含まれている場合、申請が却下されることがありますので、ご了承ください。',
      finish_info_desc_mo:
        '参考資料が不足している場合や、<br /> 不適切な内容が含まれている場合、<br />申請が却下されることがありますので、ご了承ください。',
      file_upload_count_error_title: 'アップロード数の上限超過',
      file_upload_count_error_desc: '"最大3つまで登録できます。<br/> 3つ以下にアップロードしてください。"',
      file_upload_confirm: '確認',
      file_upload_size_error_title: 'アップロード容量超過',
      file_upload_size_error_desc:
        '"最大50MBまで登録できます。<br/>50MB以下のファイルをアップロードしてください。"',
      file_upload_error_title: 'ファイルアップロードに失敗しました。',
      file_upload_error_desc:
        '再び行うか、<a href="mailto:partner@marppleshop.com">partner@marppleshop.com.</a><br/>にお問い合わせください。',
      apply_cancel: 'キャンセル',
      creator_apply: 'クリエイター申請',
      apply_desc:
        '電話番号やメールアドレスが間違っている場合、 <br /> マープルショップの作成リンクが届きません。 <br /> 正しい情報であることをご確認ください。',
      agree_personal: '個人情報の収集および利用に同意してください。',
      agree_age: '満14歳以上に同意してください。',
      file_uploading: 'ファイルをアップロード中です。アップロード後に再び行ってください。',
      brand_validation_error: '英字／ハングル／数字を組み合わせて2字以上20字以内',
      fail_same_email:
        "同じメールが既に申請されています。メールが来ない場合、迷惑メールフォルダを確認してください。<br/>それでも見当たらない場合、<a href='mailto:partner@marppleshop.com'>partner@marppleshop.com</a>にお問い合わせください。",
      fail_apply:
        "クリエイター申請が完了していません。<br/>再び行うか、<a href='mailto:partner@marppleshop.com'>partner@marppleshop.com</a>にお問い合わせください。",
    },
    membership: {
      join: 'メンバーシップに参加',
      join_success: 'メンバー登録完了',
      product: 'メンバーシップ商品',
      plan: 'プラン',
      error: {
        token_expired_title: 'メンバーシップ認証の有効期限が切れました',
        token_expired_description:
          '長時間使用されていなかったため、メンバーシップ認証の有効期限が切れました。<br/>認証のためにページが再読み込みされます。',
        widget_activate_title: 'メンバーシップウィジェットエラー',
        widget_activate_description:
          'メンバーシップウィジェットを表示する前にエラーが発生しました。<br/>ウィジェットを再読み込むためにページが再読み込みされます。',
      },
      payment: 'メンバーシップの支払い',
      go_join_button_label: 'メンバーシップに参加',
      go_join_button_label_already: 'メンバーシップ加入中',
      common: {
        membership: 'メンバーシップ',
      },
      main: {
        title: 'メンバーシップ',
        sub_title: 'Membership',
        description: '私たちのつながりがもっと特別になる瞬間',
      },
      paymethod: '決済手段',
      commission: {
        title: 'コミッション',
        sub_title: 'Commission',
        description: '私だけの特別な作品',
        state_pending: '承認待ち',
        state_end: '購入確定',
        state_accepted: '作業中',
        state_on_refund: '返金予定',
        state_refunded: 'キャンセル／返金',
        state_task_done: '完了',
      },
      support: {
        title: 'サポート',
        sub_title: 'Support',
        description: '創作を続ける力、クリエイターキャンペーンに参加しよう！',
        go_support_button_label: '今すぐ支援',
      },
      starter_modal: {
        sub_title: 'クリエイターとファンをもっと強くつなぐ —',
        title: 'MarppleShopクリエイターメンバーシップスターター募集中！',
        desc: '2025年3月に正式リリース予定のMarppleShopクリエイターメンバーシップ機能を<br/>一足先に体験していただくスタータークリエイターを募集します。<br/>大切なファンに特別な特典と体験を提供し、<br/>新たな収益を生み出すMarppleShopメンバーシップスターターになりましょう！',
        guide: 'メンバーシップサービス紹介',
        apply: 'メンバーシップスターターに申し込む',
        not_today: '今日は表示しない',
        desc_mobile:
          '2025年3月に正式リリース予定の<br/>MarppleShopクリエイターメンバーシップ機能を<br/>いち早く体験いただけるスタータークリエイターを募集します。<br/>ファンに特別な特典と体験を提供し、<br/>新しい収益を創出できる<br/>MarppleShopメンバーシップスターターになりましょう！',
      },
      membership_detail: 'メンバーシップ詳細',
      support_detail: 'サポート詳細',
      commission_detail: 'コミッション詳細',
    },
    popup: {
      close_today: '今日表示しない',
      close: '閉じる',
    },
    creator_ranking: {
      title_main: '{{tab}} クリエイター',
      sub_title: '多彩なクリエイターの魅力が爆発！',
      realtime: 'リアルタイム',
      weekly: '週間',
      monthly: '月間',
      list_title: '{{tab}} クリエイターランキング Top 100',
    },
    collaboration: {
      title: 'コラボ提案',
      creator_name: 'クリエイター名',
      collaboration_type: '提案の種類',
      collaboration_type_description: '複数選択可能',
      collaboration_category: 'コラボカテゴリ',
      collaboration_category_placeholder: 'カテゴリを選択',
      collaboration_category_etc_placeholder: 'コラボカテゴリを直接入力してください。',
      proposal_content: '提案内容',
      proposal_content_placeholder:
        'クリエイターへのコラボ提案内容を入力してください。\n1. 提案理由と要約\n2. 共同購入：商品名／販売価格／販売手数料（％）\n3. 広告：商品名／広告タイプ（ブランデッド、YouTubeショート、TikTokなど）／広告費用\n4. ライブ配信：商品名／価格／インセンティブ構造（出演料または販売手数料）',
      proposal_content_description: 'お問い合わせ内容は最大2000バイトまで入力可能です。',
      brand_name: '会社／ブランド名',
      brand_name_placeholder: '会社／ブランド名を入力してください。',
      brand_url: 'ブランドサイトURL',
      brand_url_placeholder: 'ブランドサイトのURLを入力してください。',
      manager_name: '担当者名',
      manager_name_placeholder: '担当者名を入力してください。',
      manager_tel: '担当者の連絡先',
      manager_tel_placeholder: '担当者の連絡先を入力してください。',
      manager_email: '担当者のメールアドレス',
      manager_email_placeholder: '担当者のメールアドレスを入力してください。',
      announcement: {
        explanation:
          '「コラボ提案」は、ブランドがコラボを希望するクリエイターを選び、<strong>ブランドコマースの提案を行うページ</strong>です。',
        response:
          '提案内容をご記入いただくと、<strong>マプルショップの担当者が5営業日以内に</strong>ご記入いただいた連絡先へご返信いたします。',
        rejection: '提案内容はクリエイターの意思により却下される場合があります。',
        apply:
          'マプルショップクリエイターに登録をご希望の方は、<a href="{{href}}">マプルショップクリエイター申し込み</a>をご利用ください。',
      },
      type: {
        group_buy: '共同購入',
        ads: '広告',
        live: 'ライブ配信',
        tiktok: 'TikTokショップ（海外）',
        youtube: 'YouTubeショッピング（海外）',
      },
      category: {
        food: 'フード',
        beauty: 'ビューティー',
        fashion_accessory: 'ファッション／アクセサリー',
        electronics: '家電／電子機器',
        home_living: 'ホーム／リビング',
        pets: 'ペット',
        sports: 'スポーツ',
        travel: '旅行',
        etc: 'その他',
      },
      alert: {
        success_title: 'コラボ提案が完了しました',
        success_description:
          'ご記入いただいた連絡先へ5営業日以内にご連絡いたします。\nクリエイターの意向などにより却下される場合があることをご了承ください。',
      },
      cancel: 'キャンセル',
      proposal_collaboration: 'コラボ提案',
    },
    section_title: {
      plugin: {
        soldout_label: '売り切れ商品を除外',
        see_more: 'もっと見る',
      },
      section_tabs: {
        popup_store: 'ポップアップ',
        curation: 'キュレーション',
        creator_view: 'クリエイタービュー',
        creator_ranking: 'クリエイターランキング',
        plus_shop: 'プラスショップ',
        creator_search: 'クリエイター',
        photo_review: 'フォトレビュー',
        partners: 'パートナーズ',
      },
      sub_title: {
        popup_store: 'MarppleShopだけで出会える',
        creator_ranking: '多彩なクリエイターの魅力が爆発！',
        creator_search: '自分好みのクリエイターを発見！',
        plus_shop: 'MarppleShopで出会える公式グッズ',
        latest_curation: '最新キュレーション',
        latest_creator_view: '最新クリエイタービュー',
        latest_contents: '最新コンテンツ',
        creator_product: 'クリエイター商品',
        partners: '마플샵의 공식 크리에이터',
      },
    },
    partners: {
      apply_button: '今すぐ応募',
      apply_sub_title: 'マプルショップグッズ パートナーズ',
      apply_sub_title_mo: 'グッズでつながる創作の世界',
      apply_title: 'マプルショップの公式パートナー<br />クリエイターをご紹介します！',
      apply_title_mo: 'マプルショップの<br />公式パートナー',
      apply_description:
        'クリエイターはコンテンツ制作に専念し、<br />マプルショップが企画から販売まで全ての工程をサポートします。',
      footer_apply_title: '私もパートナーに挑戦してみようかな？',
      footer_apply_description: '今すぐマプルショップと一緒に、あなたの世界をグッズで広げましょう。',
    },
    creator_summary: {
      compact:
        '<div><b data-user-count class="{{bold}}">{{cart_user_count}}</b><span>人のファンが</span></div><div><b data-product-count class="{{bold}}">{{cart_product_count}}</b><span>個をカート追加中！</span></div>',
      normal:
        '<div><strong class="{{bold}}">{{cart_user_count}}</strong><span>人が</span></div><div><b class="{{bold}}">{{name}}</b><span>のグッズを</span></div><div><strong class="{{bold}}">{{cart_product_count}}</strong><span>点カートに入れています！</span></div>',
      fan: 'ファン',
      fan_letter: 'ファンレター',
      like_count: '人',
      fan_letter_count: '<span>{{fan_letter_count}}</span><span>通</span>',
      category_none: '未分類',
      not_cart_summary:
        '<div><b class="{{bold}}">{{name}}</b><span>のグッズをカートに入れてください！</span></div>',
    },
    creator_search: {
      search_result: '<span class="{{klass}}">{{search_count}}</span> 件の検索結果',
      search_module: {
        title: 'MarppleShopクリエイターのすべて',
        sub_title: '魅力的な<br />クリエイターに会いましょう！',
        sub_title_mo: '魅力的な<br />クリエイターに会いましょう！',
        place_holder: 'クリエイター名を入力してください。',
        recent_search: '最近キーワード',
        delete_auto_completes: 'すべて削除',
      },
      card: {
        fan: 'ファン',
        fan_letter: 'ファンレター',
        ranking: 'ランキング',
        shop_button_label: 'ショップへ',
        proposal_button_label: 'コラボ提案',
      },
    },
    ranking: {
      realtime: 'リアルタイム',
      realtime_best: 'リアルタイムベスト',
      weekly: '週間',
      weekly_best: '週間ベスト',
      monthly: '月間',
      monthly_best: '月間ベスト',
      cate_roots: {
        ranking: 'ランキング',
        goods: 'グッズランキング',
        handmade: 'Handmade ランキング',
        brand_deal: 'Brand Deal ランキング',
        ebook: 'E-BOOK ランキング',
      },
    },
    product_ranking: {
      title: '人気商品ランキング',
      description: '最も人気のある商品をご覧ください！',
    },
    landing: {
      file: {
        helper_message: 'PDF、PPTX、JPG、PNGなど20MB以下のファイルをアップロードしてください。',
        not_available_file: 'アップロードできないファイルです。もう一度お試しください。',
        file_size_error: 'アップロード可能容量を超えました。',
      },
      popup_store: {
        submit: 'オンラインポップアップストア申請',
        motion_description: 'クリエイターコマースプラットフォーム、MarppleShopと共にする',
        motion_title: 'オンラインで作る特別な経験、<br />MarppleShopポップアップストア',
        ad_title_1:
          'オフラインポップアップストア<br/>場所のレンタル、商品制作、運営人件費...<br/>コストが負担になっていますか？',
        mo_ad_title_1: 'ポップアップストアの費用が<br/>負担になっていますか？',
        ad_description_1:
          'ご心配なく！MarppleShopポップアップストアはクリエイターコマースプラットフォーム、<br/>MarppleShopに露出されるオンラインポップアップストアで、別途のレンタル費用が発生しません。<br/>また、商品制作からオンライン販売、配送までMarppleShopがすべてサポートします！',
        mo_ad_description_1:
          'MarppleShopポップアップストアはクリエイターコマースプラットフォーム、<br/>MarppleShopに露出されるオンラインポップアップストアで、別途のレンタル<br/>費用が発生しません。また、商品制作からオンライン<br/>販売、配送までMarppleShopがすべてサポートします！',
        ad_title_2:
          '新製品発売、カムバック、イベントなど<br/>ファンが驚くような<br/>イベントを考えていますか？',
        mo_ad_title_2: 'ファンが驚くような<br/>イベントを構想中ですか？',
        ad_description_2:
          'すでに多くの企業ブランド、クリエイターがファンに<br/>特別な商品とコンテンツを披露したいとき<br/>MarppleShopポップアップストアを活用しています！',
        mo_ad_description_2:
          'すでに多くの企業ブランド、クリエイターがファンに<br/>特別な商品とコンテンツを披露したいとき<br/>MarppleShopポップアップストアを活用しています！',
        ad_title_3: 'オフラインポップアップストア<br/>在庫が残ることを<br/>心配していますか？',
        mo_ad_title_3: '在庫が残ることを<br/>心配していますか？',
        ad_description_3:
          'ご心配なく！<br/>MarppleShopポップアップストアはPODベースの商品制作で<br/>在庫なしで1つのポップアップストア商品も販売できます！',
        mo_ad_description_3:
          'ご心配なく！MarppleShopポップアップストアはPODベースの<br/>商品制作で在庫なしで1つのポップアップストア<br/>商品も販売できます！',
        ad_title_4: 'オフラインポップアップストア<br/>終了後、残った在庫<br/>どうしていますか？',
        mo_ad_title_4: 'オフラインポップアップストア<br/>以降、残りの在庫は？',
        ad_description_4:
          'もしかしてポップアップストア販売在庫商品を中古マーケットや<br/>オープンマーケットで販売する予定ですか？<br/>オフラインポップアップストアに訪問できなかったお客様に<br/>MarppleShopポップアップストアで特別な経験を提供してください！',
        mo_ad_description_4:
          'もしかしてポップアップストア販売在庫商品を中古マーケットやオープンマーケットで販売する予定ですか？オフラインポップアップストアに訪問できなかったお客様にMarppleShopポップアップストアで特別な経験を提供してください！',
        statistics_title:
          'MarppleShopは制作ノウハウを基盤に<br/>持続的に成長している<br/>クリエイターコマースプラットフォームです！',
        statistics_date: '2024年1月基準',
        statistics_creator_count: '活動クリエイター',
        statistics_member_count: '会員数',
        statistics_product_category_count: '制作可能な商品カテゴリー',
        statistics_marpple_product_count: 'MarppleShopで制作した商品',
        statistics_brand_count: 'プラス企業／ブランド',
        statistics_popupstore_count: 'MarppleShopでこれまで立ち上げたポップアップストア',
        mo_statistics_title:
          'MarppleShopは制作ノウハウを<br/>基盤に持続的に<br/>成長しているクリエイター<br/>コマースプラットフォームです！',
        mo_statistics_date: '2024年1月基準',
        mo_statistics_creator_count: '活動クリエイター',
        mo_statistics_member_count: '会員数',
        mo_statistics_product_category_count: '制作可能商品カテゴリー',
        mo_statistics_marpple_product_count: 'MarppleShopで制作した商品',
        mo_statistics_brand_count: 'プラス企業／ブランド',
        mo_statistics_popupstore_count: '立ち上げたポップアップストア',
        exhibition_title: 'MarppleShopとクリエイターが<br/>共に作り上げる<br/>MarppleShopポップアップストア',
        exhibition_description:
          'MarppleShopポップアップストアはMarppleShopとクリエイターが共に商品を作って販売できるサービスで、商品企画、制作、販売、配送までMarppleShopがすべてサポートします。',
        exhibition_plan: 'ポップアップストア企画',
        exhibition_plan_description:
          'クリエイターと共にポップアップストア<br/>販売商品とコンテンツを企画します。',
        exhibition_produce: '企画商品制作',
        exhibition_produce_description: '限定版商品、特別商品など<br/>PODではない、企画商品も制作します！',
        exhibition_sale: 'ポップアップストア販売',
        exhibition_sale_description: '制作された商品をMarppleShop<br/>ポップアップストアを通じて販売します。',
        exhibition_delivery: '配送及び在庫管理',
        exhibition_delivery_description:
          '配送と在庫管理だけでなく<br/>カスタマーサービスまでMarppleShopがすべて対応します。',
        case_title:
          'すでに多数のブランド／クリエイターが<br/>MarppleShopポップアップストアを通じて<br/>成功的な結果を導き出しました！',
        case_transaction: '取引額',
        case_ordered: '注文量',
        case_duration: '販売期間',
        case_transaction_a: '24億8千万ウォン',
        case_ordered_a: '約77,000個',
        case_duration_a: '18日',
        case_transaction_b: '14億9千万ウォン',
        case_ordered_b: '約89,000個',
        case_duration_b: '15日',
        case_transaction_c: '約10億ウォン',
        case_ordered_c: '約56,000個',
        case_duration_c: '15日',
        case_transaction_d: '約16.5億ウォン',
        case_ordered_d: '約54,000個',
        case_duration_d: '15日',
        case_transaction_e: '約9.2億ウォン',
        case_ordered_e: '約51,000個',
        case_duration_e: '11日',
        portfolio_title: 'MarppleShop X クリエイター<br/>ポップアップストア商品ポートフォリオ',
        portfolio_description:
          'MarppleShopが提供するデザイン商品以外にも特別に企画したい<br/>ポップアップストア商品があれば、MarppleShopが企画から制作まですべてサポートします！',
        mo_portfolio_description:
          'MarppleShopが提供するデザイン商品以外にも特別に企画<br/>したいポップアップストア商品があれば、MarppleShopが企画<br/>から制作まですべてサポートします！',
        popup_store_title: 'MarppleShopと共にした<br/>多彩なポップアップストア',
        popup_store_button: 'MarppleShopポップアップストアをもっと見る',
        bottom_title: '夢のオンラインポップアップストア、<br/>MarppleShopと一緒に作ってみましょう！',
        mo_bottom_title: 'オンラインポップアップストア、<br/>MarppleShopと一緒に<br/>作ってみましょう！',
        bottom_button: 'オンラインポップアップストア申請',
        submit_form_title: 'MarppleShopオンラインポップアップストア申請',
        submit_form_description: '特別なオンラインポップアップストアを立ち上げてみませんか？',
        submit_form_creator: 'クリエイター／ブランド名を入力してください（必須）',
        submit_form_is_creator: 'すでにMarppleShopクリエイターですか？',
        submit_form_is_creator_yes: 'はい',
        submit_form_is_creator_no: 'いいえ',
        submit_form_domain: 'ドメイン',
        submit_form_company: '会社名を入力してください（任意）',
        submit_form_manager: '担当者氏名（必須）',
        submit_form_manager_email: '担当者メールアドレス（必須）',
        submit_form_manager_phone: '担当者連絡先（数字のみ入力）（必須）',
        submit_form_sns:
          'Youtube、Instagram、X（Twitter）など運営しているSNSチャンネルアドレスを入力してください（任意）',
        submit_form_file: 'クリエイター／ブランド紹介書があれば添付してください（任意）',
        submit_form_other:
          'MarppleShopポップアップストアで販売したい商品や、提案内容を記入してください（任意）',
        submit_form_guide: '担当パートナーが確認後、営業日基準約5日以内に返信いたします。',
        submit_form_agree: '個人情報提供同意',
        submit_form_agree_content:
          '<strong>個人情報収集/利用目的：</strong>MarppleShopポップアップストアサービス申請のための本人確認<br/>収集する個人情報の項目：会社名、氏名、メール、連絡先<br/>個人情報の保有及び利用期間：利用目的終了時点まで',
        submit_form_button: 'オンラインポップアップストア申請書を提出する',
        submit_form_creator_error: '存在しないドメインです。確認後、再度入力してください。',
        submit_form_email_error: '正しい形式のメールアドレスを入力してください。',
        submit_form_phone_error: '正しい形式の連絡先を入力してください。',
        mo_submit_form_creator: 'クリエイター／ブランド名（必須）',
        mo_submit_form_is_creator: 'MarppleShopクリエイターですか？',
        mo_submit_form_domain: 'ドメイン',
        mo_submit_form_company: '会社名（任意）',
        mo_submit_form_manager: '担当者氏名（必須）',
        mo_submit_form_manager_email: '担当者メールアドレス（必須）',
        mo_submit_form_manager_phone: '担当者連絡先（数字のみ入力）（必須）',
        mo_submit_form_sns: '運営しているSNSチャンネルアドレス（任意）',
        mo_submit_form_file: 'クリエイター／ブランド紹介書（任意）',
        mo_submit_form_other:
          'MarppleShopポップアップストアで販売したい商品や、提案内容を記入してください（任意）',
        mo_submit_form_button: '申請書を提出する',
        submit_success_modal_title: '申請書提出完了',
        submit_success_home_modal_title: 'マプルショップホームの修正が完了しました',
        submit_success_studio_modal_title: 'スタジオ全体の修正が完了しました',
        submit_fail_modal_title: '提出失敗',
        submit_success_modal:
          'オンラインポップアップストア申請書が<br/>正常に提出されました。<br/>速やかに検討し、ご連絡いたします。',
        submit_fail_modal:
          'システムエラーにより<br>申請が提出されませんでした。<br>partner@marppleshop.comにお問い合わせください。',
      },
      plus: {
        submit: 'MarppleShopプラス申請',
        motion_title: 'IPコマースを始める<br/>最も速く簡単な方法、<br/>MarppleShopプラス',
        motion_description:
          'IPコマースプラットフォーム構築から商品製作、注文、配送、カスタマーサービスまで<br/>企業のEコマースに必要なすべてのインフラを提供するワンストップソリューション',
        mo_motion_description:
          '企業のEコマースに必要な<br/>すべてのインフラを提供するワンストップソリューション',
        statistics_title: 'IP市場はコンテンツから<br/>ビジネスへと変化しています',
        mo_statistics_title: 'IP市場は<br/>コンテンツからビジネスへと<br/>変化しています',
        statistics_description:
          'コンテンツIP（Intellectual Property：知的財産権）は<br/>様々なチャネルで消費され、話題性とトレンドが生まれています',
        statistics_chart_title: 'IPコマースは毎年30%<br/>成長しています',
        mo_statistics_chart_title: 'IPコマースは<br/>毎年30%成長しています',
        statistics_chart_description:
          'IPコマースを包括する「キャラクターライセンス部門」の<br/>グローバル市場規模は3300億ドル（443兆ウォン）に成長',
        statistics_chart_source: '韓国コンテンツ振興院（2022）',
        statistics_circle_title: '国内ファンダム経済規模は<br/>約7兆9千億ウォン！',
        statistics_circle_description: '多数のエンターテイメント企業が<br/>次々とIPコマース事業に進出',
        statistics_circle_source: '2022年基準',
        case_title: 'しかし、ますます障壁が高くなるIPコマース<br/>どのように対応していますか？',
        mo_case_title: 'ますます障壁が高くなる<br/>IPコマースにどのように<br/>対応していますか？',
        case_mcn_title: 'MCN企業<br/>コマースMD',
        case_mcn_description:
          'コンテンツ消費速度が速すぎます！<br/>コンテンツ生産と消費サイクルに合わせて商品を<br/>早く制作する必要がありますが、MOQ負担、在庫負担もあり、作れる商品も限定的です！',
        mo_case_mcn_description:
          'コンテンツ消費速度が速すぎます！<br/>コンテンツ生産と消費サイクルに合わせて商品を早く制作<br/>する必要がありますが、MOQ負担、在庫負担もあり、作れ<br/>る商品も限定的です！',
        case_game_title: 'ゲーム会社<br/>新規事業開発チーム長',
        case_game_description:
          '自社ゲームキャラクターを活用してグッズを<br/>テストベッドとして作ってみましたが、手続きが非常に<br/>複雑で難しかったです。MOQもかなりでした。<br/>工場に制作を依頼して作ってもらい配送されるまで<br/>このすべての過程は戦争そのものでした！',
        mo_case_game_description:
          '自社ゲームキャラクターを活用してグッズを<br/>テストベッドとして作ってみましたが、手続きが非常に複雑で難<br/>しかったです。MOQもかなりでした。工場に制作を依頼<br/>して作ってもらい配送されるまでこのすべての過程は戦争そのも<br/>のでした！',
        case_webtoon_title: 'ウェブトゥーンサービス<br/>IPビジネスチーム長',
        case_webtoon_description:
          '人気ウェブトゥーンTシャツは発売即完売するほどファンたちの継続的なリクエストがありますが、200名を超える作家たちとそれに伴う膨大な量のコンテンツを素材にグッズを作るのは簡単なことではありません。',
        mo_case_webtoon_description:
          '人気ウェブトゥーンTシャツは発売即完売するほどファンたちの継<br/>続的なリクエストがありますが、200名を超える作家たち<br/>とそれに伴う膨大な量のコンテンツを素材にグッズを作<br/>るのは簡単なことではありません。',
        case_entertain_title: 'エンターテイメント<br/>代表',
        case_entertain_description:
          '所属アーティストのグッズコマースサイトを<br/>作ろうと思っていますが、ドメインからデザイン、開発まで...一から十までプラットフォーム構築のためにやるべきことが多すぎて始める勇気が出ません。',
        mo_case_entertain_description:
          '所属アーティストのグッズコマースサイトを作ろうと思<br/>っていますが、ドメインからデザイン、開発まで...一から十<br/>までプラットフォーム構築のためにやるべきことが多すぎて始<br/>める勇気が出ません。',
        case_creator_title: 'クリエイター企業<br/>CS担当',
        case_creator_description:
          '会社所属クリエイターによって販売する商品が多様な分、お客様のニーズも多様で要求事項が複雑なのに各解決過程まで手間がかかるので、対応するのが非常に難しいです。',
        mo_case_creator_description:
          '会社所属クリエイターによって販売する商品が多様な<br/>分、お客様のニーズも多様で要求事項が複雑なのに各解決過<br/>程まで手間がかかるので、対応するのが非常に難し<br/>いです。',
        commerce_title: 'IPコマース、もう<br/>心配しないでください！',
        commerce_description:
          'MarppleShopプラスを通じて商品開発から生産と品質管理、<br/>在庫及び物流管理、プラットフォーム構築から運営まで —<br/>ブランドコマースに必要な多くの時間とコストを節約できます。',
        mo_commerce_description:
          'MarppleShopが提供するデザイン商品以外にも<br/>特別に企画したいポップアップストア商品があれば、<br/>MarppleShopが企画から制作まですべてサポートします！',
        commerce_product: '商品開発',
        commerce_quality: '品質管理',
        commerce_platform: 'プラットフォーム構築及び運営',
        commerce_sale: '商品販売',
        commerce_inventory: '在庫及び物流管理',
        commerce_delivery: '配送及び運営、カスタマーサービス',
        exhibition_title: 'MarppleShopプラスと一緒なら、<br/>1200余種類の商品制作を簡単に！',
        exhibition_description:
          '国内初のオンラインIPコマースソリューションを開発し、<br/>商品制作から注文、配送、カスタマーサービスまで — ワンストップソリューションを持つ<br/>MarppleShopプラスと共に新しいビジネスを始めてみましょう。',
        mo_exhibition_title: 'MarppleShopプラスと一緒なら、<br/>1200余種類の<br/>商品制作を簡単に！',
        mo_exhibition_description:
          '国内初のオンラインIPコマースソリューションを開発し、<br/>商品制作から注文、配送、カスタマーサービスまで —<br/>ワンストップソリューションを持つMarppleShopプラスと共に<br/>新しいビジネスを始めてみましょう。',
        ad_title_1: '驚くべき商品品質と<br/>ドロップシッピングサービス！',
        ad_description_1:
          'MarppleShopプラスは国内最高レベルの品質の商品制作と<br/>ドロップシッピングサービス<span>*</span>を通じた簡単な在庫管理、<br/>配送までをすべてお約束します。',
        ad_guide_1:
          'ドロップシッピングサービスは、販売者が商品在庫を全く管理せず、<br/>業者を通じて顧客に販売及び配送する注文処理方法です。',
        ad_title_2: '企業ブランドコマース<br/>プラットフォーム構築も<br/>簡単に！',
        ad_description_2:
          'Eコマースプラットフォームを企業のニーズに合わせて<br/>カスタマイズでき、個別所属セラーストアを<br/>一度に作成し、簡単に管理できます。',
        ad_title_3: '直接制作した3P商品<br/>Eコマースソリューションも<br/>可能です！',
        ad_description_3:
          '直接制作した3P商品も簡単に商品を登録し<br/>販売及び配送ができるプロセスを提供します。',
        ad_title_4: 'コマース運営と<br/>カスタマーサービスまで<br/>すべて提供します',
        ad_description_4:
          'MarppleShopプラスは複雑で難しかったオンラインコマースの<br/>顧客相談や商品問い合わせ、返品、交換案内など<br/>すべての運営プロセスを提供します。',
        mo_ad_title_1: '驚くべき商品品質と<br/>ドロップシッピングサービス！',
        mo_ad_title_2: '企業ブランドコマース<br/>プラットフォーム構築も簡単に！',
        mo_ad_title_3: '直接制作した3P商品<br/>Eコマースソリューションも可能！',
        mo_ad_title_4: 'コマース運営と<br/>カスタマーサービスまですべて提供！',
        solution_title: 'MarppleShopプラスは<br/>企業向けカスタマイズ管理ソリューションも<br/>提供します',
        solution_description:
          '管理ページを通じて簡単にデータ分析から、<br/>管理者権限設定、決済、商品管理など<br/>コマース運営に必要なすべての機能が提供されます。',
        solution_report: 'データ分析及び<br/>レポート',
        solution_store: 'ストア及び<br/>商品管理',
        solution_creator: 'クリエイター<br/>管理',
        solution_ecommerce: '3P Eコマース<br/>管理',
        solution_site: 'サイト及び<br/>ページ管理',
        solution_manage: '管理者及び<br/>マネージャー権限管理',
        portfolio_title:
          'すでに多数の企業 / ブランドが<br/>MarppleShopプラスを活用して<br/>IPビジネスを実現しています',
        portfolio_description:
          '多数のクリエイターを持つMCN企業から、様々なIPを持つ<br/>コンテンツ企業、様々なプロジェクトを展開する企業まで —<br/>MarppleShopプラスを活用して簡単にIPビジネスを実現しています。',
        mo_portfolio_title: '多数の企業 / ブランドが<br/>MarppleShopプラスでIP<br/>ビジネスを実現しています',
        mo_portfolio_description:
          '多数のクリエイターを持つMCN企業から、<br/>様々なIPを持つコンテンツ企業、様々なプロジェクトを<br/>展開する企業まで — MarppleShopプラスを活用して<br/>簡単にIPビジネスを実現しています。',
        portfolio_button: 'MarppleShopプラスポートフォリオ',
        bottom_title: '企業だけのIPコンテンツさえあれば、<br/>IPビジネスを始めてみましょう！',
        mo_bottom_title: '企業だけの<br/>IPコンテンツさえあれば、<br/>IPビジネスを始めてみましょう！',
        plus_apply: 'MarppleShopプラス申請',
        submit_form_title: 'MarppleShopプラス申請',
        submit_form_description:
          '様々なIPコンテンツを持つ企業/ブランドであれば、MarppleShopプラスをお申し込みください。',
        submit_form_company: '会社名',
        submit_form_company_category: '企業形態',
        submit_form_manager: '担当者氏名',
        submit_form_manager_email: '担当者メールアドレス',
        submit_form_manager_phone: '担当者連絡先（数字のみ入力）',
        submit_form_file: '会社紹介書（任意）',
        submit_form_other:
          '御社が保有しているIPコンテンツの紹介とMarppleShopプラスと一緒に取り組みたい事業提案内容を記入してください。（任意）',
        submit_form_agree: '個人情報提供同意',
        submit_form_agree_content:
          '<strong>個人情報収集/利用目的：</strong>MarppleShopプラスサービス申請のための本人確認<br/>収集する個人情報の項目：会社名、氏名、メール、連絡先<br/>個人情報の保有及び利用期間：利用目的終了時点まで',
        submit_form_marketing: '広報マーケティング活用同意（任意）',
        submit_form_marketing_content:
          'MarppleShopに登録されたアセットは広報マーケティング目的で活用される可能性があります。',
        submit_form_button: 'MarppleShopプラス申請書を提出する',
        submit_form_email_error: '正しい形式のメールアドレスを入力してください。',
        submit_form_phone_error: '正しい形式の連絡先を入力してください。',
        submit_form_guide: '担当パートナーが確認後、営業日基準約5日以内に返信いたします。',
        mo_submit_form_company: '会社名',
        mo_submit_form_manager: '担当者氏名',
        mo_submit_form_manager_email: '担当者メールアドレス',
        mo_submit_form_manager_phone: '担当者連絡先（数字のみ入力）',
        mo_submit_form_file: '会社紹介書（任意）',
        mo_submit_form_other:
          '御社が保有しているIPコンテンツの紹介とMarppleShopプラスと一緒に取り組みたい事業提案内容を記入してください。（任意）',
        mo_submit_form_button: '申請書を提出する',
        submit_success_modal_title: '申請書提出完了',
        submit_fail_modal_title: '提出失敗',
        submit_success_modal:
          'MarppleShopプラス申請書が<br/>正常に提出されました。<br/>速やかに検討し、ご連絡いたします。',
        submit_fail_modal:
          'システムエラーにより<br>申請が提出されませんでした。<br>partner@marppleshop.comにお問い合わせください。',
        enterprise_category: '企業形態',
        private_enterprise: '個人企業',
        corporate_enterprise: '法人企業',
        public_enterprise: '公企業',
        social_enterprise: '社会的企業',
        etc_enterprise: 'その他',
      },
      handmade: {
        scale_title: '熱い情熱を持った <br /> ハンドメイドクリエイター、あなたも',
        mo_scale_title: '熱い情熱を持った <br /> ハンドメイドクリエイター <br /> あなたも',
        scale_description: '今はMarppleShopで',
        craft_title_1: 'HOME DECO AND LIVING <br /> HANDMADE CREATOR',
        craft_title_2: 'JEWELRY AND ACCESSORIES <br /> HANDMADE CREATOR',
        craft_title_3: 'EMBROIDERY AND KNITTING <br /> HANDMADE CREATOR',
        craft_description_1: '優しく温かい <br /> 情熱を持つあなたも',
        craft_description_2: '熱気に満ちた熱い <br/> 情熱を持つあなたも',
        craft_description_3: '一針一針粘り強い <br /> 情熱を持つあなたも',
        video_card_title_1: 'MarppleShopで想像できるすべてのことを <br /> 現実にしてみてください',
        mo_video_card_title_1: 'MarppleShopで <br /> 想像できるすべてのことを <br /> 現実にしてみてください',
        video_card_title_2: 'クリエイターの大切な趣味が作品になり <br /> 世界に光を放つ瞬間',
        mo_video_card_title_2: 'クリエイターの <br /> 大切な趣味が作品になり <br /> 世界に光を放つ瞬間',
        video_card_title_3: 'あなたの夢が現実になるその瞬間、 <br /> MarppleShopがいつも共にあります',
        mo_video_card_title_3:
          'あなたの夢が <br /> 現実になるその瞬間、 <br /> MarppleShopがいつも共にあります',
        links_title: 'ハンドメイドクリエイター <br />なぜMarppleShopなのか？',
        links_card_title_1: '自分だけのブランドショップ、 <br /> 本当に簡単に作れます',
        links_card_description_1:
          '私が作ったハンドメイド作品をより引き立てるために <br />\n           MarppleShopで自分だけのブランドショップを作ってみてください。 <br />\n           簡単な設定だけで自分のショップを簡単にオープンし <br />\n           ハンドメイド商品を陳列して販売できます。 <br />\n           ロゴ、バナー画像、詳細ページなどを自由に設定して <br />\n           あなただけの創作世界をより際立たせてみてください！',
        mo_links_card_description_1:
          '私が作ったハンドメイド作品をより引き立てるために <br />\n         MarppleShopで自分だけのブランドショップを作ってみてください。 <br />\n         簡単な設定だけで自分のショップを簡単にオープンし <br />\n         ハンドメイド商品を陳列して販売できます。',
        mo_links_card_sub_description_1:
          'ブランドロゴ、バナー画像、詳細ページなどを自由に <br />\n         設定してあなただけの創作世界をより際立たせてみてください！',
        links_cta_button_text_1: 'ハンドメイド/DIY商品を見る',
        links_card_title_2: 'MarppleShop制作配送商品と共に <br />販売収益を高めてみましょう。',
        links_card_description_2:
          'デザインさえあれば制作から梱包、配送、顧客対応、在庫管理まで <br /> 全過程をすべてサポートするMarppleShop制作配送商品を販売できます。 <br /> 複雑な物流管理や制作過程を気にせずに自分がデザインした商品を簡単に販売できます。 <br /> クリエイターが創作活動だけに集中できるようにサポートします。',
        mo_links_card_description_2:
          'デザインさえあれば制作から梱包、配送、顧客対応、 <br /> 在庫管理まで全過程をすべてサポートする <br /> MarppleShop制作配送商品を販売できます。',
        mo_links_card_sub_description_2:
          '複雑な物流管理や制作過程を気にせずに <br /> 自分がデザインした商品を簡単に販売できます。 <br /> クリエイターが創作活動だけに集中できるようにサポートします。',
        links_cta_button_text_2: 'グッズ商品を見る',
        links_card_title_3: 'MarppleShopは韓国初の<br />YouTube ショッピング公式パートナーです',
        links_card_description_3:
          'MarppleShopは韓国初のYouTubeショッピング公式パートナーです。 <br /> YouTube、Instagramなど様々なSNSチャンネルと自分のブランドショップ連動を通じて <br /> ファンはどこでも私が作った商品に出会えます。 <br /> YouTubeショッピング機能を活用して動画コンテンツと <br /> 商品購入をつなげ、より生き生きとした顧客体験を提供してみてください。',
        mo_links_card_description_3:
          'MarppleShopは韓国初のYouTubeショッピング公式パートナーです。 <br /> YouTube、Instagramなど様々なSNSチャンネルと <br /> 自分のブランドショップ連動を通じてファンはどこでも <br /> 私が作った商品に出会えます。',
        mo_links_card_sub_description_3:
          'YouTubeショッピング機能を活用して動画コンテンツと商品購入を <br /> つなげ、より生き生きとした顧客体験を提供してみてください。',
        links_cta_button_text_3: 'MarppleShop X YouTubeショッピングとは？',
        links_card_title_4: 'あなただけのノウハウが詰まった <br /> 図案販売から電子書籍販売まで',
        links_card_description_4:
          'MarppleShopでは実物商品以外にも自分だけのノウハウがたっぷり詰まった <br /> デジタル図案や電子書籍まで販売できます。 <br /> 自分だけの創作ノウハウを込めたデジタルコンテンツを販売しながら <br /> ハンドメイドを通じたデジタル/電子書籍の収益創出が可能です。',
        mo_links_card_description_4:
          'MarppleShopでは実物商品以外にも自分だけのノウハウがたっぷり詰まったデジ <br /> タル図案や電子書籍まで販売できます。 <br /> 自分だけの創作ノウハウを込めたデジタルコンテンツを販売しながらハンド <br /> メイドを通じたデジタル/電子書籍の収益創出が可能です。',
        links_cta_button_text_4: 'デジタル/電子書籍を見る',
        links_card_title_5: 'あなたの大切な作品で <br /> ユニークなポップアップストアを開いてみてください',
        links_card_description_5:
          'MarppleShopはポップアップストアの聖地、ソンス洞で <br /> オフラインポップアップストア空間を運営しています。 <br /> MarppleShopポップアップストアはクリエイターが創作と <br /> 商品販売のみに集中できるように <br /> 洗練された什器と簡単で便利な販売システムを備えています。',
        mo_links_card_description_5:
          'MarppleShopはポップアップストアの聖地、ソンス洞で <br /> オフラインポップアップストア空間を運営しています。',
        mo_links_card_sub_description_5:
          'MarppleShopポップアップストアはクリエイターが <br /> 商品創作と販売のみに集中できるように <br /> 洗練された什器と簡単で便利な販売システムを備えています。',
        links_cta_button_text_5: 'MarppleShopポップアップストアとは？',
        statistics_date: '2024年10月基準データ',
        statistics_title_1: '活動クリエイター',
        statistics_title_2: '上位15％月平均収入',
        statistics_title_3: '累積取引額',
        statistics_title_4: '会員数',
        statistics_title_5: '再購入率',
        statistics_title:
          'MarppleShopは <br /> 持続的に成長している <br /> クリエイターコマースプラットフォームです',
        statistics_description:
          '自分だけのブランドを作り、アイデアをMarppleShopで実現してみてください。 <br /> MarppleShopでは自分が作ったハンドメイド商品からグッズ、デジタル/電子書籍まですべて販売できます。',
        mo_statistics_description:
          '自分だけのブランドを作り、アイデアを <br /> MarppleShopで実現してみてください。 <br /> MarppleShopでは自分が作ったハンドメイド商品から <br /> グッズ、デジタル/電子書籍まですべて販売できます。',
        statistics_button: '実現してみよう、MarppleShop',
        portfolio_banner_title:
          'あなたのように情熱的な<br/> ハンドメイドクリエイターたちのMarppleShopストーリー',
        mo_portfolio_banner_title:
          'あなたのように情熱的な<br/> ハンドメイドクリエイターたちの<br/> MarppleShopストーリー',
        interview_title: 'MarppleShopのおかげで <br />私の作品をお客様に <br />より早くお披露目できました',
        interview_sub_title:
          'MarppleShopがクリエイターたちにどのような変化をもたらしたのか<br />彼らの話を直接聞いてみてください。',
        interview_description:
          'MarppleShopを通じて自分だけのブランドをどのように成長させたのか、<br /> ハンドメイド作品を世界と共有しながらどのような経験をしたのか、<br /> クリエイターたちの話を通じて確認してみてください。 <br /> MarppleShopがあなたにも特別な機会を提供します。',
        interview_creator_1: 'レジンアートブランド<br /> ちょっとした村',
        interview_sub_description_1:
          '最近の人々は様々なメディアに触れながら特別な趣味を<br/> 持つのが難しいです。私はレジンクラフト初心者でも簡単に作れる様々なキットを構成して販売したいです。',
        interview_description_1:
          'YouTubeでも注文が可能でお客様が便利に購入できましたが、クラフトに関心のある視聴者が動画を見て必要な材料をすぐに購入できるシステムが大きな利点です。<br/> さらに海外配送も始めたいです。K-カルチャーが流行し、私たちのYouTubeチャンネルにも外国人視聴者が増えました。<br/> MarppleShopで海外配送が可能なら大きな助けになると思います。',
        interview_creator_2: 'ライフスタイルブランド<br/>トゥッカッタ',
        interview_sub_description_2:
          'MarppleShopを通じてブランド「トゥッカッタ」を知らせ、様々な作業で新しい経験を伝えたいです。またMarppleShopを通じて<br/> 他の分野のクリエイターとのコラボレーションや<br/> 新しい実験的な挑戦の機会が生まれればいいと思います。',
        interview_description_2:
          'ソンス洞ポップアップストアとオンラインショップの運営が便利で、MarppleShopの様々なサポートのおかげでスムーズに進行されました。<br/> 商品制作からマーケティング、ポップアップまでワンストップでサポートされる経験が良く、在庫負担なしで商品を簡単に制作して<br/> 販売できるMarppleShop制作配送商品があるので時間とコストを<br/> 節約できました。',
        interview_creator_3: 'テキスタイルクラフトブランド<br/>クンストホイテ',
        interview_sub_description_3:
          '工芸品とグッズを結びつけたとき何を望み<br/> どのように生きているかについての顧客の様々な考えを把握できる<br/> 良い機会になると思います。<br/> クンストホイテの自然の色と染色技法が込められた<br/> 様々な作業で工芸の特性を生かしてMarppleShopお客様のニーズを<br/> 把握して企画し製作された商品を披露したいと思います。',
        interview_description_3:
          '特に、MarppleShopはお客様との協業形態で発展可能性が高く<br/> 世界に一つだけの自分だけのものを作るのに最適化されて<br/> いると思います。クンストホイテが追求する方向性と<br/> よく合い、新しいシナジーにつながると期待しています。',
        benefit_title: 'MarppleShop、今がチャンスです',
        benefit_description:
          'MarppleShopがハンドメイドクリエイターの皆様のために特別な特典を用意しました。 <br />MarppleShopを通じてクリエイターの作品をより多くのファンに披露してください！',
        mo_benefit_description:
          'MarppleShopがハンドメイドクリエイターの皆様のために <br /> 特別な特典を用意しました。',
        benefit_card_title_1: '出店販売手数料0%',
        mo_benefit_card_title_1: '出店販売手数料5% → 0%',
        benefit_card_sub_description_pc_1: '※ PG会社手数料（3.52%）は別途です。',
        benefit_card_sub_description_pc_2: '※ MarppleShop手数料ポリシーは随時変更される場合があります。',
        benefit_card_sub_description_1: '※ PG/カード会社手数料除外',
        benefit_card_title_2: 'オフラインポップアップストアサポート',
        mo_benefit_card_title_2: 'オフラインポップアップストアサポート',
        benefit_card_description_2:
          '<span>MarppleShopオフラインポップアップストア</span>で作家様だけのポップアップを開いてみてください。 <br /> ハンドメイド商品だけでなくグッズ商品まで拡張して売上を増やしてみてください。<br /> MarppleShopが<span>商品企画からポップアップ企画、VMD</span>まで成功的な進行をサポートします。',
        mo_benefit_card_description_2:
          '<span>MarppleShopオフラインポップアップストア</span>で<br /> 作家様だけのポップアップを開いてみてください。<br /> ハンドメイド商品だけでなくグッズ商品まで<br /> 拡張して売上を増やしてみてください。<br /> MarppleShopが<span>商品企画からポップアップ企画、VMD</span>まで<br /> 成功的な進行をサポートします。',
        benefit_card_sub_description_2: 'オフラインポップアップストア事例を見る',
        benefit_card_title_3: '広告及び広報サポート',
        mo_benefit_card_title_3: '広告及び広報サポート',
        benefit_card_description_3:
          'キャンペーン期間中に出店されたハンドメイドクリエイター対象に<br /> <span>MarppleShopオンラインポップアップストア</span>参加機会を提供します。<br /> ハンドメイドに合ったストーリーテリングを基にしたオンラインポップアップストアを進行して<br /> 効果的にブランドと商品を露出してみてください。<br /> <span>MarppleShopのオンサイトとSNSチャンネル</span>を通じて積極的な広報をサポートします。',
        mo_benefit_card_description_3:
          'キャンペーン期間中に出店されたハンドメイドクリエイター対象に<span>MarppleShopオンラインポップアップストア</span>参加機会を提供します。<br /> ハンドメイドに合ったストーリーテリングを基にした<br /> オンラインポップアップストアを進行して効果的に<br /> ブランドと商品を露出してみてください。<br /> <span>MarppleShopのオンサイトとSNSチャンネル</span>を通じて<br /> 積極的な広報をサポートします。',
        benefit_card_sub_description_3: 'オンラインポップアップストア事例を見る',
        benefit_card_title_4: 'YouTubeショッピングサポート',
        mo_benefit_card_title_4: 'YouTubeショッピングサポート',
        benefit_card_description_4:
          'YouTubeチャンネルも運営していますか？ <br /> YouTube収益創出条件に合致したクリエイターの場合、 <br /> <span>MarppleShopと連動してYouTubeショッピング機能</span>を活用できます。 <br /> 自分だけのコンテンツに商品を連携させてお客様に特別なショッピング体験を提供してください。',
        mo_benefit_card_description_4:
          'YouTubeチャンネルも運営していますか？<br /> YouTube収益創出条件に合致したクリエイターの場合、<br /> <span>MarppleShopと連動してYouTubeショッピング機能</span>を<br /> 活用できます。<br /> 自分だけのコンテンツに商品を連携させてお客様に<br /> 特別なショッピング体験を提供してください。',
        benefit_card_sub_description_4: 'MarppleShop X YouTubeショッピングとは？',
        benefit_info_title: '特典参考事項',
        benefit_info_desc_1:
          'オンライン/オフラインポップアップストアは空間レンタル日程とMarppleShop審査により進行可能可否が決定されます。',
        benefit_info_desc_2:
          'YouTubeショッピングの場合、YouTube収益創出条件とMarppleShopクリエイター承認過程を経た後、活用が可能です。',
        story_nav_1: '1. 指先から始まる',
        story_nav_2: '2. 真心と愛を込めて',
        story_nav_3: '3. 同じ夢',
        story_nav_4: '4. 誰かの日常',
        story_nav_5: '5. MarppleShopと共に',
        story_title: 'MarppleShopと共に、 <br /> 私の作品が伝える特別なストーリー',
        mo_story_title: 'MarppleShopと共に、 <br /> 私の作品が伝える <br /> 特別なストーリー',
        story_content_title_1: '私の指先から始まるストーリー',
        story_content_description_1:
          '私が作り出した作品一つ一つが誰かの心を温かくします。 <br /> 世界に一つしかないその特別なものを直接作ったあなた、その真心とストーリーをより多くの人々と分かち合ってみてください。 <br /> MarppleShopはあなたの小さな創作の瞬間がより大きな喜びになるように、 <br /> より多くの人々と出会えるようにサポートします。',
        mo_story_content_description_1:
          '私が作り出した作品一つ一つが誰かの心を<br /> 温かくします。<br /> 世界に一つしかないその特別なものを直接作ったあなた、<br /> その真心とストーリーをより多くの人々と分かち合ってみてください。<br /> MarppleShopはあなたの小さな創作の瞬間がより大きな喜びになるように、<br /> より多くの人々と出会えるようにサポートします。',
        story_content_link_1: 'ハンドメイド/DIY商品を見る',
        story_content_title_2: '真心と愛で完成された作品',
        story_content_description_2:
          '指先で一つ一つ真心込めて作られた作品たち、その中には創作者の愛と情熱がそのまま込められています。 <br /> MarppleShopはクリエイターの作品がより輝くように最善を尽くしてサポートします。 <br /> あなたの作品がより多くの人々の日常に溶け込み、大切な瞬間を作っていくように一緒にいきましょう。',
        mo_story_content_description_2:
          '指先で一つ一つ真心込めて作られた作品たち、 <br /> その中には創作者の愛と情熱がそのまま込められています。 <br /> MarppleShopはクリエイターの作品がより輝くように <br /> 最善を尽くしてサポートします。 <br /> あなたの作品がより多くの人々の日常に溶け込み、 <br /> 大切な瞬間を作っていくように一緒にいきましょう。',
        story_content_link_2: 'ハンドメイド/DIYキュレーション',
        story_content_title_3: '同じ夢を持つ人々との出会い',
        story_content_description_3:
          'MarppleShopには同じ夢を見るクリエイターたちがいます。 <br /> お互いの情熱を応援し、インスピレーションを与え合いながら成長するMarppleShopで <br /> 私たちは一つのコミュニティになります。 <br /> 創作のストーリーを私たちと共有し、より良い世界を作ってみてください。',
        mo_story_content_description_3:
          'MarppleShopには同じ夢を見るクリエイターたちがいます。 <br /> お互いの情熱を応援し、インスピレーションを与え合いながら成長するMarppleShopで <br /> 私たちは一つのコミュニティになります。 <br /> 創作のストーリーを私たちと共有し、より良い世界を作ってみてください。',
        story_content_link_3: 'クリエイターコミュニティ',
        story_content_title_4: 'あなたの作品が誰かの日常に特別さを',
        story_content_description_4:
          '指先から生まれたその特別な作品が誰かにとっては毎日の小さな幸せになることがあります。 <br /> MarppleShopはその瞬間を一緒に作っていく旅を応援します。 <br /> 創作のすべての過程で、あなたの努力が美しい結実につながるように一緒にいきましょう。',
        mo_story_content_description_4:
          '指先から生まれたその特別な作品が誰かにとっては <br /> 毎日の小さな幸せになることがあります。 <br /> MarppleShopはその瞬間を一緒に作っていく旅を応援します。 <br /> 創作のすべての過程で、あなたの努力が美しい結実に <br /> つながるように一緒にいきましょう。',
        story_content_link_4: 'ハンドメイドレビュー',
        story_content_title_5: 'MarppleShopと一緒に、より多くのチャンスを',
        story_content_description_5:
          '自分のストーリーをMarppleShopで始めましょう。<br />出店時のさまざまな特典とサポートを通じて、より多くのファンと出会い、より多くの可能性を実現できます。<br />クリエイターの夢を広げる舞台であるMarppleShopで新しい挑戦を始めましょう。',
        mo_story_content_description_5:
          '自分のストーリーをMarppleShopで始めましょう。<br />出店時のさまざまな特典とサポートを通じて、<br />より多くのファンと出会い、より多くの可能性を実現できます。<br />クリエイターの夢を広げる舞台であるMarppleShopで<br />新しい挑戦を始めましょう。',
        story_content_link_5: 'クリエイター申請する',
        bottom_title: 'クリエイターのおかげで<br />世界はもっと温かく幸せになります。',
        mo_bottom_title: 'クリエイターのおかげで<br />世界はもっと温かく、<br />幸せになります。',
        bottom_description:
          '大切な人へのささやかな贈り物からイベント、特別な記念日まで―<br />MarppleShopはハンドメイドが届ける価値を尊重し、<br />ハンドメイドクリエイターの皆様の成長のために継続的に努力してまいります。',
        mo_bottom_description:
          '大切な人へのささやかな贈り物から<br />イベント、特別な記念日まで―<br />MarppleShopはハンドメイドが届ける価値を尊重し、<br />ハンドメイドクリエイターの皆様の成長のために<br />継続的に努力してまいります。',
      },
    },
  },
  콘텐츠: 'コンテンツ',
  의류: 'アパレル',
  스포츠: 'スポーツ',
  굿즈: 'グッズ',
  스티커: 'ステッカー',
  패션잡화: 'アクセサリー',
  '토이/취미': 'トイ/趣味',
  '쿠션/패브릭': 'ファブリック',
  '폰 악세서리': 'スマホアクセ',
  '문구/오피스': '文具/オフィス',
  키즈: 'キッズ',
  애견: 'ペット',
  리빙: 'リビング',
  '디지털/전자책': 'デジタル/電子書籍',
  액자: 'フレーム',
  '도서/음반': '図書/アルバム',
  핸드메이드: 'ハンドメイド/DIY',
  식품: '食品',
  withdrawal: {
    title: '会員退会',
    '고객님 마플샵을 정말 탈퇴하시나요?': 'お客様、Marpple ・ MarppleShopを本当に退会されますか？😢',
    '회원 탈퇴 전 아래 사항을 숙지해 주세요.': '会員退会前に以下の事項を確認してください。',
    description_1:
      '一般会員の場合、会員退会後に再登録は可能ですが、購入されたコンテンツ、注文履歴、保有ポイント、そして進行中の定期購入中のメンバーシップもすべて削除されます。',
    description_2:
      'MarppleShopクリエイターの場合、<b>進行中の取引「0件」、残余収益金額「0ウォン」であり、</b>販売商品の配送出荷/CS/収益精算がすべて完了し、<b>販売中のメンバーシップがない場合に退会が可能です。</b>退会後には、クリエイターショップと商品販売/精算履歴などの会員情報がすべて削除され、復旧できません。',
    description_3:
      '退会されてもすでにご購入いただいた商品は正常な配送処理が行われ、お客様の個人情報は会員退会後も商品の返品やアフターサービスのため「電子商取引等における消費者保護に関する法律」に基づくMarpple ・ MarppleShopの顧客情報保護ポリシーに従って管理されます。',
    description_4:
      '退会手続きが難しい場合、カスタマーセンター(<a href="tel:1566-5496">1566-5496</a>または<a href="mailto:help@marpple.com">help@marpple.com</a>)にお問い合わせいただければご案内させていただきます。',
    '진행 중인 거래': '進行中の取引',
    몇건: '{{count}}件',
    '잔여 수익 금액': '残余収益金額',
    몇원: 'KRW {{amount}}',
    '보유 포인트': '保有ポイント',
    몇포인트: '{{point}}P',
    그동안:
      'MCOをご利用いただきありがとうございます。<br/>より良いサービスでお客様にまたお会いできるよう努めます。',
    취소: 'キャンセル',
    탈퇴하기: '退会する',
    '정말 탈퇴하시겠어요?': '本当に退会しますか？',
    '모든 회원 정보는 즉시 삭제': 'すべての会員情報が削除され、復元できません。続行しますか？',
    네: 'はい',
    실패: '失敗',
    '회원 탈퇴 완료': '退会完了',
    '회원 탈퇴 불가': '退会失敗',
    '진행 중인 거래 0건':
      '進行中の取引\'0件\'、残余収益金額「¥0」でなければ脱退ができません。<br/>詳しい内容はMarppleShopスタジオでご確認ください。進行が難しい場合は、<a href="tel:{{tel}}" style="color: #1C75FF;" >{{tel}}</a>または<a href="mailto:{{email}}" style="color: #1C75FF;" >{{email}}</a>までお問い合わせいただければ、ご案内いたします。',
    alert_content:
      'MCOをご利用いただきありがとうございます。<br/>より良いサービスでお客様にまたお会いできるよう努めます。',
    membership: '販売中のメンバーシップ',
    몇개: '{{count}}件',
  },
  maker: {
    icon: {
      custom_asset: 'Custom Asset',
      status_txt1: '使用中のコレクション',
      custom_user_asset: 'Custom User Asset',
    },
  },
  labs: {
    setting: {
      info: 'キャラクター設定が商品に反映されるまで時間がかかる場合があります。',
    },
    main: {
      login_1: '나만의 메이플스토리를 구매하기 위해서는',
      login_2: '로그인이 필요해요!',
      login_3: '로그인하러가기 →',
      no_chracter_1: '고객님의 메이플스토리 캐릭터가 존재하지 않아요!',
      no_chracter_2: '넥슨 계정 확인 후 다시 시도해 주세요.',
      change_button: '캐릭터 감정 / 모션 바꾸기',
      no_chracter_1_1: 'お客様のメイプルストーリーキャラクター情報を確認できませんでした！',
    },
    error: {
      collabo_1:
        '콜라보 아이템 착용으로 캐릭터가 로드되지 않았습니다.<br />상품을 구매하기 위해 콜라보 아이템 해제 후 아래의 버튼을 눌러주세요!',
      reload: '캐릭터 리로드',
      title: '콜라보 아이템 로드 불가',
      message:
        '고객님의 일부 캐릭터 정보를 불러오지 못하였습니다.<br />\n 콜라보 아이템을 해제한 후 다시 시도해 주세요.',
      item_name: '아이템명',
      notice:
        '지속적으로 동일한 문제 발생 시 1566-7960 혹은<br/><span style="text-decoration: underline; text-decoration-skip-ink : none; text-underline-position :from-font ">nexon@marpple.com</span>으로 문의 바랍니다.',
      special_world: {
        title: '스페셜 월드 캐릭터 로드 불가',
        message: '스페셜 월드의 캐릭터는 불러올 수 없어요.',
        name: '캐릭터명',
      },
      character_load: {
        title: '캐릭터 로드 실패',
        message_1: '고객님의 메이플스토리 캐릭터 정보를 불러 올 수 없습니다.',
        message_2: '캐릭터 정보 확인 후 재시도 해주세요.',
      },
    },
    reload: {
      message: '최근 접속 기준 최대 50개의 캐릭터가 노출됩니다.',
      button: '캐릭터 리로드',
    },
    can_not_load: {
      title: '캐릭터 로드 불가',
      message:
        '마지막 접속일이 23년 12월 21일 이후인 캐릭터만 불러올 수 있습니다.<br />캐릭터를 로드하시려면 게임에 접속해주세요',
      last_date: '마지막 접속일',
    },
    character_not_selected: {
      message: '캐릭터 선택을 위해<br/>LABS 홈으로 이동합니다.',
    },
  },
  admin: {
    in_review_title: 'クリエイター審査',
    in_review_desc: '審査待ちの申請者を確認し、合格/不合格を処理できる審査ページです。',
  },
  creator_shop: {
    section_title: {
      products: 'グッズ',
      reviews: 'レビュー',
      fundings: 'ファンディング',
      goods_products: 'グッズ',
      handmade_products: 'ハンドメイド',
      brand_deal_products: 'ブランドディール',
      ebook_products: '電子書籍',
    },
    fan_letters: {
      title: 'ファンレター',
      placeholder_pc_login: 'お気に入りのクリエイターに&#13;&#10;心を込めたファンレターを送ってみましょう！',
      placeholder_pc_logout:
        'ファンレターはログイン後に作成できます。&#13;&#10;ログインして気持ちを届けに行きましょう！',
      placeholder_mo_login: '心を込めたファンレターを送ってみましょう！',
      placeholder_mo_logout: 'ログインして心を込めたファンレターを送ってみましょう！',
      pd_title:
        '現在、<span class="pd-contents__fan-letter-preview-blue">{{like_count}}</span>人のファンが応援中！',
      pd_title_zero: 'ファンがクリエイターを応援中！',
      pd_title_02: 'のファンレター',
      replies: '{{comment_count}}コメント',
      write: 'ファンレター投稿',
      fake: {
        nickname1: 'キラキラマイラブ',
        body1: '感動をくれる私のクリエイター！<br />あなたのおかげで毎日がキラキラ輝いています！',
        nickname2: '応援マイラブ',
        body2: '最愛のおかげで世界が美しい！<br />いつも応援しています。大好き！',
        nickname3: 'ときときマイラブ',
        body3: '大好きすぎて何度も見ちゃう！<br />いつもときめく作品をありがとうございます！',
      },
      hidden_user: '無効化されたアカウント',
    },
    creator_notes: {
      title: 'クリエイターのひとこと',
    },
    profile: {
      fan: 'ファン',
      become: 'ファンになる',
      became: '応援中',
      expand_more: 'もっと見る',
      expand_less: '簡略表示',
      popular_title: 'ランキング',
      popular_title_mo: 'ランキング',
      rank: '{{- rank}}<span class="{{klass}}">位</span>',
    },
    common: {
      all_count: '合計 {{-count_text}}個',
    },
    home: {
      title: 'ホーム',
    },
    sns_icon: {
      youtube: 'Youtube',
      instagram: 'Instagram',
      grafolio: 'Grafolio',
      facebook: 'Facebook',
      twitch: 'Twitch',
      twitter: 'Twitter',
      x: 'X',
      comic_naver: 'Naver Webtoon',
      kakao_page: 'KakaoPage',
      daum_webtoon: 'Daum Webtoon',
      blog: 'Naver Blog',
      ticktok: 'TikTok',
      behance: 'Behance',
      brunch: 'Brunch',
      spooncast: 'Spooncast',
      daum_cafe: 'Daum Cafe',
      chzzk: 'CHZZK',
      afreecatv: 'AfreecaTV',
      ciety: 'CIETY',
      website: 'Website',
    },
    creator_main_banner: {
      ranking_unit: '位',
      see_more: 'もっと見る',
      the_other_links: '他 {{count}} 件のリンク',
      profile_edit: 'プロフィール編集',
      monthly_ranking: '{{month}}月ランキング {{ranking}}位',
      weekly_ranking: '{{month}}月 第{{week}}週 ランキング {{ranking}}位',
      realtime_ranking: 'リアルタイムランキング {{ranking}}位',
    },
    home_modal: {
      monthly_ranking: '月間ランキング {{ranking}}位',
      weekly_ranking: '週間ランキング {{ranking}}位',
      realtime_ranking: 'リアルタイムランキング {{ranking}}位',
      monthly_recorded_at: '{{year}}年{{month}}月',
      weekly_recorded_at: '{{year}}年{{month}}月 第{{week}}週',
      realtime_recorded_at: '{{minute}}分前に更新',
    },
    fan_service: 'ファンサービス',
    lnb_creator_shop: {
      shophome: 'ホーム',
      funding: 'ファンディング',
      goods: 'グッズ',
      handmade: 'ハンドメイド',
      branddeal: 'ブランドディール',
      ebook: '電子書籍',
      membership: 'メンバーシップ',
      commission: 'コミッション',
      support: 'ドネーション',
      fanletter: 'ファンレター',
      review: 'レビュー',
    },
    banner_and_profile_edit_modal: {
      banner_and_profile_edit: 'バナー・プロフィールの変更',
      mo_banner_image_upload_description: '3:2 比率 | 最小 横幅750px | JPG, JPEG, PNG | 最大 1MB',
    },
    realtime_ranking: 'リアルタイムランキング',
  },
  shipping_guide: {
    departure_date_info: '配送出発日のご案内',
    departure_date_info_marpple_desc1:
      'MarppleShop配送商品とMarppleShop制作配送商品を一緒に注文すると、配送料は一度だけ請求されます。',
    departure_date_info_marpple_desc2:
      '一緒に注文した商品の配送出発日が異なる場合、最も遅い日付に合わせて発送されます。',
    departure_date_info_marpple_desc3:
      '予約販売(プレオーダー)商品は配送が遅れる可能性があるため、他の商品とは別々に注文することをお勧めします。',
  },
  cta: {
    coming_soon: '発売予定',
    limited: '限定版購入',
    limited_not_show_count: '限定版購入',
    quantity: '残り{{quantity}}個',
    membership: 'メンバーシップに加入して購入',
    limited_sold_out: '販売終了しました！',
    sold_out: '完売しました！',
    dtg: 'PCで購入できます！',
    membership_app: 'まずPCでメンバーシップに加入してください。',
    remain_days: '{{days}}日',
    remain_time: 'あと<span>{{days}}</span><span>{{hours}}:{{minutes}}:{{seconds}}</span><span>です</span>',
    remain_time_coming_soon:
      '<span>{{days}}</span><span>{{hours}}:{{minutes}}:{{seconds}}後に発売予定</span>',
  },
  브랜드딜: 'ブランドディール',
  cast_on_air: {
    creator_on_air: 'クリエイター・オンエア',
  },
  settings_arrangement: {
    goods: 'グッズ',
    handmade: 'ハンドメイド',
    brand_deal: 'ブランドディール',
    ebook: '電子書籍',
    page_title: '並び替え順',
    description: 'ドラッグ＆ドロップで順序を変更してください。',
  },
  studio_kakao: {
    studio_usage_inquiry: 'スタジオ問い合わせ',
    operation_know_how: 'ショップ運営ノウハウ',
  },
  studio_quick_guide: {
    studio_first_banner: {
      title: '100万ウォン稼いだら',
      description: 'マーケティング</br>A-Zサポート',
    },
    offline_popup_store: {
      title: 'オフラインポップアップ',
      description: 'ソンスドンで特別な空間を<br />運営してみましょう',
    },
    youtube_shopping: {
      title: 'YouTubeショッピング',
      description: 'YouTubeで商品を<br />販売してみましょう',
    },
    additional_fee_closed: {
      title: 'マープルショップ製作配送商品\n追加収益終了',
      description: '11月1日の販売分から適用されます。',
    },
    additional_fee_change: {
      title: '運営ポリシー変更のお知らせ',
      description: 'マープルショップ製作配送商品の追加収益提供が<br/> 終了します(11月1日の販売分から適用)',
    },
  },
  ad_res_finish_page: {
    kakao_guide: {
      description:
        'カカオチャンネルを追加すると、<br />クリエイター活動に必要な最新情報をいち早くチェックできます',
      button_40_text: '追加する',
      description_mo: 'カカオで最新情報と成長ノウハウを<br />いち早く手に入れましょう',
      button_40_text_mo: '追加する',
    },
  },
  curation: {
    gnb: {
      menu_title: 'キュレーション',
    },
    curation_list: {
      sub_copy_text: 'MarppleShopが注目するトレンド',
      main_copy_text: 'キュレーション',
    },
    main_page_curation_list_view: {
      section_title_text: 'キュレーション',
      see_more: 'もっと見る',
    },
    curation_detail_page: {
      related_products: '関連商品',
      section_title: '最新キュレーション',
      section_control_text: 'もっと見る',
      button_text: 'もっと見る',
    },
    latest_curation_feed_page: {
      detached_tab_text: 'もっと見る',
      curation_products_text: '関連商品',
      section_title: '最新キュレーション',
      button_text: 'もっと見る',
    },
  },
  card_product: {
    badge_main: {
      trend: '急上昇',
      popular: '人気',
      stock_left: '残り{{count}}個',
      time_left_until_end: '終了まで',
      time_left_seconds: '{{seconds}}秒',
      time_left_minutes: '<span>{{minutes}}</span><span>分残り</span>',
      time_left_hours: '<span>{{hours}}</span><span>時間残り</span>',
      days_left: '{{days}}日残り',
      limited: '{{quantity}}個限定',
      free_shipping: '送料無料',
      just_sold_seconds: '{{seconds}}秒',
      just_sold_minutes: '{{minutes}}分',
      just_sold_hours: '{{hours}}時',
      just_sold_ago: '前販売',
    },
    badge_sub: {
      free_shipping: '送料無料',
      time_left_until_end: '終了まで',
      time_left_seconds: '{{seconds}}秒',
      time_left_minutes: '<span>{{minutes}}</span><span>分残り</span>',
      time_left_hours: '<span>{{hours}}</span><span>時間残り</span>',
      time_left_days: '<span>{{days}}</span><span>日残り</span>',
      stock_left: '残り{{count}}個',
      popular: '人気',
      limited: '{{quantity}}個限定',
      trend: '急上昇',
    },
    count_view: {
      watching: '{{watcher_count}}人が視聴中',
    },
    realtime: {
      seconds: '{{seconds}}秒',
      minutes: '{{minutes}}分',
      hours: '{{hours}}時',
      days: '{{days}}日',
      sold_ago: '前に販売！',
    },
    review: {
      review: 'レビュー',
    },
    shop: {
      watching: '{{watcher_count}}人が視聴中',
    },
  },
  creator_view: {
    related_products: '関連商品',
    latest_creator_view: '最新クリエイタービュー',
    see_more: 'もっと見る',
  },
  preorder: {
    notable_pre_order_challenges: '注目のプレオーダーチャレンジ',
    challenge: 'チャレンジ',
    section_title_pre_order_challenge: 'プレオーダーチャレンジ',
    lnb_pre_order_challenge: 'プレオーダーチャレンジ',
    gnb_pre_order_challenge: 'プレオーダーチャレンジ',
    cta_participate_in_the_challenge: 'チャレンジに参加',
    cta_challenge_end: 'チャレンジ終了',
    participated: '{{nickname}}さんが参加しました。',
    challenge_success: 'チャレンジ成功',
    challenge_failed: 'チャレンジ終了',
  },
  digital_product_payment_completed: {
    receipt: {
      marppleshop_home: 'MarppleShopホーム',
      order_list: '購入履歴',
      order_completed: '注文完了',
      payment_completed: '決済完了しました',
      please_deposit_money: '{{month}}月{{day}}日{{hour}}時{{minute}}分までに入金してください。',
      share_it: '購入認証カードをダウンロードして友達と共有してみましょう！',
      download_now: '今すぐダウンロードしてみてください。',
      description_text_imp: '入金完了後、マイページの購入履歴からダウンロードしてください。',
      description_text:
        '決済完了したデジタル・電子書籍商品は、マイページの購入履歴から期限内にダウンロードできます。',
      download: 'ダウンロード',
    },
  },
  delivery_lead_time: {
    delivery_policy: {
      shipping_departure_date: '出荷予定日',
      select_departure_date: '出荷日を選択',
      same_day_shipping: '当日発送',
      within_business_days: '{{business_day}}営業日以内',
      hour: '{{cutoff_time}}時まで',
      upon_completion_of_payment: '入金確認後',
    },
    product_detail: {
      ship_date_title: '出荷開始',
      ship_date_specific_date: 'より順次出荷予定',
      ship_date_same_day: '本日（{{day}}）出荷予定',
      ship_date_same_day_cutoff_time: '{{cutoff_time}}までの決済で',
      ship_date_same_day_after: '出荷予定',
      sales_period_title: '販売期間',
      sales_period_from: 'より販売開始',
      sales_period_end: 'まで販売',
    },
  },
};
